(window.theme = window.theme || {}),
    (window.slate = window.slate || {}),
    console && console.log && console.log("Impulse theme (" + theme.settings.themeVersion + ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"),
    (window.lazySizesConfig = window.lazySizesConfig || {}),
    (lazySizesConfig.expFactor = 4),
    (function (e) {
        e = jQuery = e;
        (slate.utils = {
            defaultTo: function (e, t) {
                return null == e || e != e ? t : e;
            },
        }),
            (slate.a11y = {
                trapFocus: function (t) {
                    var i = t.namespace ? "focusin." + t.namespace : "focusin";
                    t.$elementToFocus || (t.$elementToFocus = t.$container),
                        t.$container.attr("tabindex", "-1"),
                        t.$elementToFocus.focus(),
                        e(document).off("focusin"),
                        e(document).on(i, function (e) {
                            t.$container[0] === e.target || t.$container.has(e.target).length || t.$container.focus();
                        });
                },
                removeTrapFocus: function (t) {
                    var i = t.namespace ? "focusin." + t.namespace : "focusin";
                    t.$container && t.$container.length && t.$container.removeAttr("tabindex"), e(document).off(i);
                },
                lockMobileScrolling: function (t, i) {
                    if (i) var n = i;
                    else n = e(document.documentElement).add("body");
                    n.on("touchmove" + t, function () {
                        return !1;
                    });
                },
                unlockMobileScrolling: function (t, i) {
                    if (i) var n = i;
                    else n = e(document.documentElement).add("body");
                    n.off(t);
                },
            }),
            (theme.Sections = function () {
                (this.constructors = {}),
                    (this.instances = []),
                    e(document)
                        .on("shopify:section:load", this._onSectionLoad.bind(this))
                        .on("shopify:section:unload", this._onSectionUnload.bind(this))
                        .on("shopify:section:select", this._onSelect.bind(this))
                        .on("shopify:section:deselect", this._onDeselect.bind(this))
                        .on("shopify:block:select", this._onBlockSelect.bind(this))
                        .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
            }),
            (theme.Sections.prototype = e.extend({}, theme.Sections.prototype, {
                createInstance: function (t, i, n) {
                    var o = e(t),
                        a = o.attr("data-section-id"),
                        s = o.attr("data-section-type");
                    if (void 0 !== (i = i || this.constructors[s])) {
                        if (n) if (this._findInstance(a)) return;
                        var r = e.extend(new i(t), { id: a, type: s, container: t });
                        this.instances.push(r);
                    }
                },
                _onSectionLoad: function (t, i, n) {
                    AOS && AOS.refreshHard();
                    var o = i || e("[data-section-id]", t.target)[0];
                    if (o) {
                        this.createInstance(o);
                        var a = i ? n : this._findInstance(t.detail.sectionId);
                        i || this._loadSubSections(), a && "function" == typeof a.onLoad && a.onLoad(t);
                    }
                },
                _loadSubSections: function () {
                    AOS && AOS.refreshHard(),
                        e("[data-subsection]").each(
                            function (t, i) {
                                this._onSectionLoad(null, i, e(i).data("section-id"));
                            }.bind(this)
                        );
                },
                _onSectionUnload: function (e) {
                    var t = this._removeInstance(e.detail.sectionId);
                    t && "function" == typeof t.onUnload && t.onUnload(e);
                },
                _onSelect: function (e) {
                    var t = this._findInstance(e.detail.sectionId);
                    t && "function" == typeof t.onSelect && t.onSelect(e);
                },
                _onDeselect: function (e) {
                    var t = this._findInstance(e.detail.sectionId);
                    t && "function" == typeof t.onDeselect && t.onDeselect(e);
                },
                _onBlockSelect: function (e) {
                    var t = this._findInstance(e.detail.sectionId);
                    t && "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
                },
                _onBlockDeselect: function (e) {
                    var t = this._findInstance(e.detail.sectionId);
                    t && "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e);
                },
                _findInstance: function (e) {
                    for (var t = 0; t < this.instances.length; t++) if (this.instances[t].id === e) return this.instances[t];
                },
                _removeInstance: function (e) {
                    for (var t, i = this.instances.length; i--; )
                        if (this.instances[i].id === e) {
                            (t = this.instances[i]), this.instances.splice(i, 1);
                            break;
                        }
                    return t;
                },
                register: function (t, i, n) {
                    this.constructors[t] = i;
                    var o = e("[data-section-type=" + t + "]");
                    n && (o = e("[data-section-type=" + t + "]", n)),
                        o.each(
                            function (e, t) {
                                this.createInstance(t, i, n);
                            }.bind(this)
                        );
                },
            })),
            (theme.Currency = (function () {
                var e = "$";
                return {
                    formatMoney: function (t, i) {
                        i || (i = theme.settings.moneyFormat), "string" == typeof t && (t = t.replace(".", ""));
                        var n = "",
                            o = /\{\{\s*(\w+)\s*\}\}/,
                            a = i || e;
                        function s(e, t, i, n) {
                            if (((t = slate.utils.defaultTo(t, 2)), (i = slate.utils.defaultTo(i, ",")), (n = slate.utils.defaultTo(n, ".")), isNaN(e) || null == e)) return 0;
                            var o = (e = (e / 100).toFixed(t)).split(".");
                            return o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (o[1] ? n + o[1] : "");
                        }
                        switch (a.match(o)[1]) {
                            case "amount":
                                n = s(t, 2);
                                break;
                            case "amount_no_decimals":
                                n = s(t, 0);
                                break;
                            case "amount_with_comma_separator":
                                n = s(t, 2, ".", ",");
                                break;
                            case "amount_no_decimals_with_comma_separator":
                                n = s(t, 0, ".", ",");
                                break;
                            case "amount_no_decimals_with_space_separator":
                                n = s(t, 0, " ");
                        }
                        return a.replace(o, n);
                    },
                    getBaseUnit: function (e) {
                        if (e && e.unit_price_measurement && e.unit_price_measurement.reference_value)
                            return 1 === e.unit_price_measurement.reference_value ? e.unit_price_measurement.reference_unit : e.unit_price_measurement.reference_value + e.unit_price_measurement.reference_unit;
                    },
                };
            })()),
            (theme.Images = (function () {
                return {
                    imageSize: function (e) {
                        if (!e) return "620x";
                        var t = e.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
                        return null !== t ? t[1] : null;
                    },
                    getSizedImageUrl: function (e, t) {
                        if (!e) return e;
                        if (null == t) return e;
                        if ("master" === t) return this.removeProtocol(e);
                        var i = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
                        if (null != i) {
                            var n = e.split(i[0]),
                                o = i[0];
                            return this.removeProtocol(n[0] + "_" + t + o);
                        }
                        return null;
                    },
                    removeProtocol: function (e) {
                        return e.replace(/http(s)?:/, "");
                    },
                    lazyloadImagePath: function (e) {
                        var t;
                        return null !== e && (t = e.replace(/(\.[^.]*)$/, "_{width}x$1")), t;
                    },
                };
            })()),
            (slate.Variants = (function () {
                function t(t) {
                    (this.$container = t.$container),
                        (this.variants = t.variants),
                        (this.singleOptionSelector = t.singleOptionSelector),
                        (this.originalSelectorId = t.originalSelectorId),
                        (this.enableHistoryState = t.enableHistoryState),
                        (this.currentVariant = this._getVariantFromOptions()),
                        e(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this));
                }
                return (
                    (t.prototype = e.extend({}, t.prototype, {
                        _getCurrentOptions: function () {
                            var t = e.map(e(this.singleOptionSelector, this.$container), function (t) {
                                var i = e(t),
                                    n = i.attr("type"),
                                    o = {};
                                return "radio" === n || "checkbox" === n ? !!i[0].checked && ((o.value = i.val()), (o.index = i.data("index")), o) : ((o.value = i.val()), (o.index = i.data("index")), o);
                            });
                            return (t = this._compact(t));
                        },
                        _getVariantFromOptions: function () {
                            var e = this._getCurrentOptions(),
                                t = this.variants,
                                i = !1;
                            return (
                                t.forEach(function (t) {
                                    var n = !0;
                                    t.options;
                                    e.forEach(function (e) {
                                        n && (n = t[e.index] === e.value);
                                    }),
                                        n && (i = t);
                                }),
                                i || null
                            );
                        },
                        _onSelectChange: function () {
                            var e = this._getVariantFromOptions();
                            this.$container.trigger({ type: "variantChange", variant: e }),
                                e &&
                                    (this._updateMasterSelect(e), this._updateImages(e), this._updatePrice(e), this._updateUnitPrice(e), this._updateSKU(e), (this.currentVariant = e), this.enableHistoryState && this._updateHistoryState(e));
                        },
                        _updateImages: function (e) {
                            var t = e.featured_image || {},
                                i = this.currentVariant.featured_image || {};
                            e.featured_image && t.src !== i.src && this.$container.trigger({ type: "variantImageChange", variant: e });
                        },
                        _updatePrice: function (e) {
                            (e.price === this.currentVariant.price && e.compare_at_price === this.currentVariant.compare_at_price) || this.$container.trigger({ type: "variantPriceChange", variant: e });
                        },
                        _updateUnitPrice: function (e) {
                            e.unit_price !== this.currentVariant.unit_price && this.$container.trigger({ type: "variantUnitPriceChange", variant: e });
                        },
                        _updateSKU: function (e) {
                            e.sku !== this.currentVariant.sku && this.$container.trigger({ type: "variantSKUChange", variant: e });
                        },
                        _updateHistoryState: function (e) {
                            if (history.replaceState && e) {
                                var t = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + e.id;
                                window.history.replaceState({ path: t }, "", t);
                            }
                        },
                        _updateMasterSelect: function (t) {
                            e(this.originalSelectorId, this.$container).val(t.id);
                        },
                        _compact: function (e) {
                            for (var t = -1, i = null == e ? 0 : e.length, n = 0, o = []; ++t < i; ) {
                                var a = e[t];
                                a && (o[n++] = a);
                            }
                            return o;
                        },
                    })),
                    t
                );
            })()),
            (slate.rte = {
                init: function () {
                    slate.rte.wrapTable(), slate.rte.wrapVideo(), slate.rte.imageLinks();
                },
                wrapTable: function () {
                    e(".rte table").wrap('<div class="table-wrapper"></div>');
                },
                wrapVideo: function () {
                    var t = e('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'),
                        i = t.add("iframe#admin_bar_iframe");
                    t.each(function () {
                        e(this).parents(".video-wrapper").length || e(this).wrap('<div class="video-wrapper"></div>');
                    }),
                        i.each(function () {
                            this.src = this.src;
                        });
                },
                imageLinks: function () {
                    e(".rte a img").parent().addClass("rte__image");
                },
            }),
            (theme.Modals = (function () {
                function t(t, i, n) {
                    var o = {
                        close: ".js-modal-close",
                        open: ".js-modal-open-" + i,
                        openClass: "modal--is-active",
                        closingClass: "modal--is-closing",
                        bodyOpenClass: "modal-open",
                        bodyOpenSolidClass: "modal-open--solid",
                        bodyClosingClass: "modal-closing",
                        closeOffContentClick: !0,
                    };
                    if (((this.id = t), (this.$modal = e("#" + t)), !this.$modal.length)) return !1;
                    (this.nodes = { $parent: e("html").add("body"), $modalContent: this.$modal.find(".modal__inner") }),
                        (this.config = e.extend(o, n)),
                        (this.modalIsOpen = !1),
                        (this.$focusOnOpen = this.config.focusOnOpen ? e(this.config.focusOnOpen) : this.$modal),
                        (this.isSolid = this.config.solid),
                        this.init();
                }
                return (
                    (t.prototype.init = function () {
                        e(this.config.open).attr("aria-expanded", "false"),
                            e(this.config.open).on("click", this.open.bind(this)),
                            this.$modal.find(this.config.close).on("click", this.close.bind(this)),
                            e("body").on(
                                "drawerOpen",
                                function () {
                                    this.close();
                                }.bind(this)
                            );
                    }),
                    (t.prototype.open = function (t) {
                        var i = !1;
                        this.modalIsOpen ||
                            (t ? t.preventDefault() : (i = !0),
                            t && t.stopPropagation && (t.stopPropagation(), (this.$activeSource = e(t.currentTarget))),
                            this.modalIsOpen && !i && this.close(),
                            this.$modal.prepareTransition().addClass(this.config.openClass),
                            this.nodes.$parent.addClass(this.config.bodyOpenClass),
                            this.isSolid && this.nodes.$parent.addClass(this.config.bodyOpenSolidClass),
                            (this.modalIsOpen = !0),
                            slate.a11y.trapFocus({ $container: this.$modal, $elementToFocus: this.$focusOnOpen, namespace: "modal_focus" }),
                            this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "true"),
                            e("body")
                                .trigger("productModalOpen")
                                .trigger("modalOpen." + this.id),
                            this.bindEvents());
                    }),
                    (t.prototype.close = function () {
                        if (this.modalIsOpen) {
                            e(document.activeElement).trigger("blur"),
                                this.$modal.prepareTransition().removeClass(this.config.openClass).addClass(this.config.closingClass),
                                this.nodes.$parent.removeClass(this.config.bodyOpenClass),
                                this.nodes.$parent.addClass(this.config.bodyClosingClass);
                            var t = this;
                            window.setTimeout(function () {
                                t.nodes.$parent.removeClass(t.config.bodyClosingClass), t.$modal.removeClass(t.config.closingClass);
                            }, 500),
                                this.isSolid && this.nodes.$parent.removeClass(this.config.bodyOpenSolidClass),
                                (this.modalIsOpen = !1),
                                slate.a11y.removeTrapFocus({ $container: this.$modal, namespace: "modal_focus" }),
                                this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "false").focus(),
                                e("body").trigger("modalClose." + this.id),
                                this.unbindEvents();
                        }
                    }),
                    (t.prototype.bindEvents = function () {
                        this.nodes.$parent.on(
                            "keyup.modal",
                            function (e) {
                                27 === e.keyCode && this.close();
                            }.bind(this)
                        ),
                            this.config.closeOffContentClick &&
                                (this.$modal.on("click.modal", this.close.bind(this)),
                                this.nodes.$modalContent.on("click.modal", function (e) {
                                    e.stopImmediatePropagation();
                                }));
                    }),
                    (t.prototype.unbindEvents = function () {
                        this.nodes.$parent.off(".modal"), this.config.closeOffContentClick && (this.$modal.off(".modal"), this.nodes.$modalContent.off(".modal"));
                    }),
                    t
                );
            })()),
            (theme.Drawers = (function () {
                function t(t, i, n) {
                    if (
                        ((this.config = { id: t, close: ".js-drawer-close", open: ".js-drawer-open-" + i, openClass: "js-drawer-open", closingClass: "js-drawer-closing", activeDrawer: "drawer--is-open", namespace: ".drawer-" + i }),
                        (this.$nodes = { parent: e(document.documentElement).add("body"), page: e("#MainContent") }),
                        (this.$drawer = e("#" + t)),
                        !this.$drawer.length)
                    )
                        return !1;
                    (this.isOpen = !1), (this.ignoreScrollLock = n), this.init();
                }
                return (
                    (t.prototype = e.extend({}, t.prototype, {
                        init: function () {
                            var t = e(this.config.open);
                            t.attr("aria-expanded", "false"),
                                t.on("click", this.open.bind(this)),
                                this.$drawer.find(this.config.close).on("click", this.close.bind(this)),
                                e("body").on(
                                    "productModalOpen",
                                    function () {
                                        this.close();
                                    }.bind(this)
                                );
                        },
                        open: function (t) {
                            t && t.preventDefault(),
                                this.isOpen ||
                                    (t && t.stopPropagation && (t.stopPropagation(), (this.$activeSource = e(t.currentTarget))),
                                    this.$drawer.prepareTransition().addClass(this.config.activeDrawer),
                                    this.$nodes.parent.addClass(this.config.openClass),
                                    (this.isOpen = !0),
                                    slate.a11y.trapFocus({ $container: this.$drawer, namespace: "drawer_focus" }),
                                    e("body")
                                        .trigger("drawerOpen")
                                        .trigger("drawerOpen." + this.config.id),
                                    this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "true"),
                                    this.bindEvents());
                        },
                        close: function () {
                            if (this.isOpen) {
                                e(document.activeElement).trigger("blur"),
                                    this.$drawer.prepareTransition().removeClass(this.config.activeDrawer),
                                    this.$nodes.parent.removeClass(this.config.openClass),
                                    this.$nodes.parent.addClass(this.config.closingClass);
                                var t = this;
                                window.setTimeout(function () {
                                    t.$nodes.parent.removeClass(t.config.closingClass);
                                }, 500),
                                    (this.isOpen = !1),
                                    slate.a11y.removeTrapFocus({ $container: this.$drawer, namespace: "drawer_focus" }),
                                    this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "false"),
                                    this.unbindEvents();
                            }
                        },
                        bindEvents: function () {
                            this.ignoreScrollLock || slate.a11y.lockMobileScrolling(this.config.namespace, this.$nodes.page),
                                this.$nodes.page.on(
                                    "click" + this.config.namespace,
                                    function (t) {
                                        var i = e(t.target);
                                        if (!this.elementInsideDrawer(i)) return this.close(), !1;
                                    }.bind(this)
                                ),
                                this.$nodes.parent.on(
                                    "keyup" + this.config.namespace,
                                    function (e) {
                                        27 === e.keyCode && this.close();
                                    }.bind(this)
                                );
                        },
                        unbindEvents: function () {
                            this.ignoreScrollLock || slate.a11y.unlockMobileScrolling(this.config.namespace, this.$nodes.page), this.$nodes.parent.off(this.config.namespace), this.$nodes.page.off(this.config.namespace);
                        },
                        elementInsideDrawer: function (e) {
                            return this.$drawer.find(e).length;
                        },
                    })),
                    t
                );
            })()),
            (theme.cart = {
                getCart: function () {
                    return e.getJSON("/cart.js");
                },
                changeItem: function (e, t) {
                    return this._updateCart({ type: "POST", url: "/cart/change.js", data: "quantity=" + t + "&id=" + e, dataType: "json" });
                },
                addItemFromForm: function (e) {
                    return this._updateCart({ type: "POST", url: "/cart/add.js", data: e, dataType: "json" });
                },
                _updateCart: function (t) {
                    return e.ajax(t).then(
                        function (e) {
                            return e;
                        }.bind(this)
                    );
                },
                updateNote: function (t) {
                    var i = { type: "POST", url: "/cart/update.js", data: "note=" + theme.cart.attributeToString(t), dataType: "json", success: function (e) {}, error: function (e, t) {} };
                    e.ajax(i);
                },
                updateCurrency: function (t) {
                    var i = {
                        type: "POST",
                        url: "/cart/update.js",
                        data: "currency=" + t,
                        dataType: "json",
                        success: function (e) {
                            location.reload();
                        },
                        error: function (e, t) {},
                    };
                    e.ajax(i);
                },
                attributeToString: function (t) {
                    return "string" != typeof t && "undefined" === (t += "") && (t = ""), e.trim(t);
                },
            }),
            e(function () {
                e("body").on("click", ".cart__checkout", function () {
                    e(this).addClass("btn--loading");
                }),
                    e("body").on("change", 'textarea[name="note"]', function () {
                        var t = e(this).val();
                        theme.cart.updateNote(t);
                    }),
                    e("body").on("click", ".cart__checkout--ajax", function (t) {
                        if (!e("#CartAgree").is(":checked")) return alert(theme.strings.cartTermsConfirmation), e(this).removeClass("btn--loading"), !1;
                    }),
                    e("body").on("click", ".cart__checkout--page", function (t) {
                        if (!e("#CartPageAgree").is(":checked")) return alert(theme.strings.cartTermsConfirmation), e(this).removeClass("btn--loading"), !1;
                    });
            }),
            (theme.QtySelector = (function () {
                var t = { input: ".js-qty__num", plus: ".js-qty__adjust--plus", minus: ".js-qty__adjust--minus" };
                function i(i, n) {
                    (this.$wrapper = i), (this.$input = i.find(t.input)), (this.$plus = i.find(t.plus)), (this.$minus = i.find(t.minus)), (this.minValue = this.$input.attr("min") || 1);
                    var o = { namespace: null, key: this.$input.data("id") };
                    (this.options = e.extend(o, n)), this.initEventListeners();
                }
                return (
                    (i.prototype = e.extend({}, i.prototype, {
                        initEventListeners: function () {
                            this.$plus.on(
                                "click",
                                function () {
                                    var e = this.validateQty(this.$input.val());
                                    this.addQty(e);
                                }.bind(this)
                            ),
                                this.$minus.on(
                                    "click",
                                    function () {
                                        var e = this.validateQty(this.$input.val());
                                        this.subtractQty(e);
                                    }.bind(this)
                                ),
                                this.$input.on(
                                    "change",
                                    function () {
                                        var e = this.validateQty(this.$input.val());
                                        this.changeQty(e);
                                    }.bind(this)
                                );
                        },
                        addQty: function (e) {
                            var t = e + 1;
                            this.changeQty(t);
                        },
                        subtractQty: function (e) {
                            var t = e - 1;
                            t <= this.minValue && (t = this.minValue), this.changeQty(t);
                        },
                        changeQty: function (t) {
                            this.$input.val(t), e("body").trigger("qty" + this.options.namespace, [this.options.key, t]);
                        },
                        validateQty: function (e) {
                            return (parseFloat(e) != parseInt(e) || isNaN(e)) && (e = 1), parseInt(e);
                        },
                    })),
                    i
                );
            })()),
            (theme.CartDrawer = (function () {
                var t = ".ajaxcart",
                    i = { drawer: "#CartDrawer", container: "#CartContainer", template: "#CartTemplate", fixedFooter: ".drawer__footer--fixed", fixedInnerContent: ".drawer__inner--has-fixed-footer", cartBubble: ".cart-link__bubble" };
                function n() {
                    (this.status = { loaded: !1, loading: !1 }), (this.drawer = new theme.Drawers("CartDrawer", "cart"));
                    var t = e(i.template).html();
                    (this.template = Handlebars.compile(t)), theme.cart.getCart().then(this.buildCart.bind(this)), this.initEventListeners();
                }
                return (
                    (n.prototype = e.extend({}, n.prototype, {
                        initEventListeners: function () {
                            e("body").on("updateCart" + t, this.initQtySelectors.bind(this)),
                                e("body").on("updateCart" + t, this.sizeFooter.bind(this)),
                                e("body").on("updateCart" + t, this.updateCartNotification.bind(this)),
                                e("body").on("drawerOpen.CartDrawer", this.sizeFooter.bind(this)),
                                e(window).on("resize" + t, e.debounce(150, this.sizeFooter.bind(this))),
                                e("body").on(
                                    "added.ajaxProduct",
                                    function () {
                                        theme.cart.getCart().then(
                                            function (e) {
                                                this.buildCart(e, !0);
                                            }.bind(this)
                                        );
                                    }.bind(this)
                                );
                        },
                        buildCart: function (n, o) {
                            if ((this.loading(!0), this.emptyCart(), 0 === n.item_count)) e(i.container).append('<p class="appear-animation appear-delay-3">' + theme.strings.cartEmpty + "</p>");
                            else {
                                var a,
                                    s = [],
                                    r = {},
                                    c = 1;
                                e.each(n.items, function (t, i) {
                                    var n;
                                    (n = null !== i.image ? i.image.replace(/(\.[^.]*)$/, "_180x$1") : "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif"),
                                        null !== i.properties &&
                                            e.each(i.properties, function (e, t) {
                                                ("_" !== e.charAt(0) && t) || delete i.properties[e];
                                            });
                                    var o = 0;
                                    if (0 !== i.line_level_discount_allocations.length)
                                        for (var a in i.line_level_discount_allocations)
                                            (o = i.line_level_discount_allocations[a].amount), (i.line_level_discount_allocations[a].formattedAmount = theme.Currency.formatMoney(o, theme.settings.moneyFormat));
                                    (c += 2),
                                        (r = {
                                            key: i.key,
                                            url: i.url,
                                            img: n,
                                            animationRow: c,
                                            name: i.product_title,
                                            variation: i.variant_title,
                                            properties: i.properties,
                                            itemQty: i.quantity,
                                            price: theme.Currency.formatMoney(i.price, theme.settings.moneyFormat),
                                            unitPrice: theme.Currency.formatMoney(i.unit_price, theme.settings.moneyFormat),
                                            unitBase: theme.Currency.getBaseUnit(i),
                                            discountedPrice: theme.Currency.formatMoney(i.price - i.total_discount / i.quantity, theme.settings.moneyFormat),
                                            discounts: i.line_level_discount_allocations,
                                            discountsApplied: 0 !== i.line_level_discount_allocations.length,
                                            vendor: i.vendor,
                                        }),
                                        s.push(r);
                                }),
                                    (c += 2);
                                var d = 0;
                                if (0 !== n.cart_level_discount_applications.length)
                                    for (var l in n.cart_level_discount_applications)
                                        (d = n.cart_level_discount_applications[l].total_allocated_amount), (n.cart_level_discount_applications[l].formattedAmount = theme.Currency.formatMoney(d, theme.settings.moneyFormat));
                                (a = {
                                    items: s,
                                    note: n.note,
                                    lastAnimationRow: c,
                                    cartDiscounts: n.cart_level_discount_applications,
                                    cartDiscountsApplied: 0 !== n.cart_level_discount_applications.length,
                                    totalPrice: theme.Currency.formatMoney(n.total_price, theme.settings.moneyFormat),
                                }),
                                    e(i.container).append(this.template(a));
                            }
                            (this.status.loaded = !0),
                                this.loading(!1),
                                theme.settings.currenciesEnabled && theme.currencySwitcher.ajaxrefresh(),
                                e("body").trigger("updateCart" + t, n),
                                window.Shopify &&
                                    Shopify.StorefrontExpressButtons &&
                                    (Shopify.StorefrontExpressButtons.initialize(),
                                    setTimeout(
                                        function () {
                                            this.sizeFooter();
                                        }.bind(this),
                                        800
                                    )),
                                !0 === o && this.drawer.open();
                        },
                        initQtySelectors: function () {
                            e(i.container)
                                .find(".js-qty__wrapper")
                                .each(
                                    function (t, i) {
                                        new theme.QtySelector(e(i), { namespace: ".cart-drawer" });
                                    }.bind(this)
                                ),
                                e("body").on("qty.cart-drawer", this.updateItem.bind(this));
                        },
                        updateItem: function (e, t, i) {
                            this.status.loading ||
                                (this.loading(!0),
                                theme.cart
                                    .changeItem(t, i)
                                    .then(
                                        function (e) {
                                            this.updateSuccess(e);
                                        }.bind(this)
                                    )
                                    .catch(
                                        function (e) {
                                            this.updateError(e);
                                        }.bind(this)
                                    )
                                    .always(
                                        function () {
                                            this.loading(!1);
                                        }.bind(this)
                                    ));
                        },
                        loading: function (t) {
                            (this.status.loading = t), t ? e(i.container).addClass("is-loading") : e(i.container).removeClass("is-loading");
                        },
                        emptyCart: function () {
                            e(i.container).empty();
                        },
                        updateSuccess: function (e) {
                            this.buildCart(e);
                        },
                        updateError: function (e) {
                            e.responseJSON && e.responseJSON.description;
                        },
                        sizeFooter: function () {
                            if (e(i.drawer).hasClass("drawer--has-fixed-footer")) {
                                var t = e(i.drawer).find(i.fixedFooter).removeAttr("style"),
                                    n = e(i.drawer).find(i.fixedInnerContent).removeAttr("style"),
                                    o = t.outerHeight();
                                n.css("bottom", o), t.css("height", o);
                            }
                        },
                        updateCartNotification: function (t, n) {
                            if(n.items.length > 0) {
                                e(i.cartBubble).html(n.item_count);
                            }
                            n.items.length > 0 ? e(i.cartBubble).addClass("cart-link__bubble--visible") : e(i.cartBubble).removeClass("cart-link__bubble--visible");
                        },
                    })),
                    n
                );
            })()),
            (theme.AjaxProduct = (function () {
                var t = { loading: !1 };
                function i(e) {
                    (this.$form = e), (this.$addToCart = this.$form.find(".add-to-cart")), this.$form.length && this.$form.on("submit", this.addItemFromForm.bind(this));
                }
                return (
                    (i.prototype = e.extend({}, i.prototype, {
                        addItemFromForm: function (e, i) {
                            if ((e.preventDefault(), !t.loading)) {
                                this.$addToCart.addClass("btn--loading"), (t.loading = !0);
                                var n = this.$form.serialize();
                                theme.cart
                                    .addItemFromForm(n)
                                    .then(
                                        function (e) {
                                            this.success(e);
                                        }.bind(this)
                                    )
                                    .catch(
                                        function (e) {
                                            this.error(e);
                                        }.bind(this)
                                    )
                                    .always(
                                        function () {
                                            (t.loading = !1), this.$addToCart.removeClass("btn--loading");
                                        }.bind(this)
                                    );
                            }
                        },
                        success: function (t) {
                            this.$form.find(".errors").remove(), e("body").trigger("added.ajaxProduct");
                        },
                        error: function (e) {
                            this.$form.find(".errors").remove(), e.responseJSON && e.responseJSON.description && this.$form.prepend('<div class="errors text-center">' + e.responseJSON.description + "</div>");
                        },
                    })),
                    i
                );
            })()),
            (theme.collapsibles = (function () {
                var t = { trigger: ".collapsible-trigger", module: ".collapsible-content", moduleInner: ".collapsible-content__inner" },
                    i = { hide: "hide", open: "is-open", autoHeight: "collapsible--auto-height" },
                    n = ".collapsible",
                    o = !1;
                function a(e, t, n, a) {
                    if ((e.removeClass(i.hide).prepareTransition().css("height", t).toggleClass(i.open, !n), !n && a)) {
                        var s = e;
                        window.setTimeout(function () {
                            s.css("height", "auto"), (o = !1);
                        }, 350);
                    } else o = !1;
                }
                return {
                    init: function () {
                        e(t.trigger).each(function () {
                            var t = e(this),
                                n = t.hasClass(i.open);
                            t.attr("aria-expanded", n);
                        }),
                            e("body, .modal__inner")
                                .off(n)
                                .on("click" + n, t.trigger, function () {
                                    if (!o) {
                                        o = !0;
                                        var n = e(this),
                                            s = n.hasClass(i.open),
                                            r = n.attr("aria-controls"),
                                            c = e("#" + r),
                                            d = c.find(t.moduleInner).outerHeight(),
                                            l = n.hasClass(i.autoHeight);
                                        s &&
                                            l &&
                                            setTimeout(function () {
                                                a(c, (d = 0), s, l);
                                            }, 0),
                                            s && !l && (d = 0),
                                            n.attr("aria-expanded", !s).toggleClass(i.open, !s),
                                            a(c, d, s, l);
                                    }
                                });
                    },
                };
            })()),
            (theme.headerNav = (function () {
                var t,
                    i,
                    n,
                    o = e(document.documentElement).add("body"),
                    a = e("#MainContent"),
                    s = {
                        wrapper: ".header-wrapper",
                        siteHeader: ".site-header",
                        searchBtn: ".js-search-header",
                        closeSearch: ".js-search-header-close",
                        searchContainer: ".site-header__search-container",
                        logoContainer: ".site-header__logo",
                        logo: ".site-header__logo img",
                        navigation: ".site-navigation",
                        megamenu: ".megamenu",
                        navContainerWithLogo: ".header-item--logo",
                        navItems: ".site-nav__item",
                        navLinks: ".site-nav__link",
                        navLinksWithDropdown: ".site-nav__link--has-dropdown",
                        navDropdownLinks: ".site-nav__dropdown-link--second-level",
                    },
                    r = { hasDropdownClass: "site-nav--has-dropdown", hasSubDropdownClass: "site-nav__deep-dropdown-trigger", dropdownActive: "is-focused", overlaidBodyClass: "overlaid-header", stickyBodyClass: "sticky-header" },
                    c = {
                        namespace: ".siteNav",
                        wrapperOverlayed: !1,
                        overlayedClass: "is-light",
                        stickyEnabledClass: "header-wrapper--sticky",
                        stickyEnabled: !1,
                        stickyActive: !1,
                        stickyInitialized: !1,
                        forceStopSticky: !1,
                        stickyClass: "site-header--stuck",
                        openTransitionClass: "site-header--opening",
                        lastScroll: 0,
                    };
                function d() {
                    e(document.activeElement).trigger("blur"),
                        o.removeClass("js-drawer-open--search").off(c.namespace),
                        e(s.searchContainer).removeClass("is-active"),
                        slate.a11y.removeTrapFocus({ $container: e(s.searchContainer), namespace: "header_search" }),
                        slate.a11y.unlockMobileScrolling(c.namespace),
                        a.off("click" + c.namespace),
                        o.off("keyup" + c.namespace);
                }
                function l() {
                    (theme.config.stickyHeader = (function () {
                        var t = 0;
                        if (
                            (e(s.megamenu).each(function () {
                                var i = e(this).outerHeight();
                                i > t && (t = i);
                            }),
                            window.innerHeight < t + 120)
                        )
                            return !1;
                        return !0;
                    })()),
                        theme.config.stickyHeader
                            ? ((c.forceStopSticky = !1),
                              (function () {
                                  c.stickyInitialized ||
                                      (o.addClass(r.stickyBodyClass),
                                      n.wrap('<div class="site-header-sticky"></div>'),
                                      h(),
                                      setTimeout(function () {
                                          h();
                                      }, 200),
                                      t.on("resize" + c.namespace, e.debounce(50, h)),
                                      t.on("scroll" + c.namespace, e.throttle(15, u)));
                                  c.stickyInitialized = !0;
                              })())
                            : (c.forceStopSticky = !0);
                }
                function h() {
                    var t = n.outerHeight(!0);
                    e(".site-header-sticky").css("height", t);
                    e(".grid__item--sidebar").length && e(".grid__item--sidebar").css("top", t + 10);
                }
                function u() {
                    if (!c.forceStopSticky) {
                        var e = t.scrollTop();
                        if (e > 150) {
                            if (c.stickyActive) return;
                            (c.stickyActive = !0),
                                n.addClass(c.stickyClass),
                                c.wrapperOverlayed && i.removeClass(c.overlayedClass),
                                setTimeout(function () {
                                    n.addClass(c.openTransitionClass);
                                }, 100);
                        } else {
                            if (!c.stickyActive) return;
                            (c.stickyActive = !1), n.removeClass(c.openTransitionClass).removeClass(c.stickyClass), c.wrapperOverlayed && i.addClass(c.overlayedClass);
                        }
                        c.lastScroll = e;
                    }
                }
                return {
                    init: function () {
                        (t = e(window)),
                            e(s.navContainerWithLogo),
                            e(s.logoContainer),
                            e(s.navigation),
                            (i = e(s.wrapper)),
                            (n = e(s.siteHeader)),
                            (c.wrapperOverlayed = theme.settings.overlayHeader = i.hasClass(c.overlayedClass)),
                            (c.stickyEnabled = n.data("sticky")),
                            c.stickyEnabled && (l(), t.on("resize" + c.namespace, e.debounce(150, l))),
                            c.wrapperOverlayed && e("body").addClass(r.overlaidBodyClass),
                            (function () {
                                var t = !1,
                                    i = !1,
                                    n = !1;
                                function o(i) {
                                    var o = i.parent();
                                    if ((o.hasClass(r.hasDropdownClass) && (o.addClass(r.dropdownActive), (t = !0)), !theme.config.isTouch && !n)) {
                                        var a = theme.config.isTouch ? "touchend" : "click";
                                        (n = !0),
                                            e("body").on(a + c.namespace, function () {
                                                d(), e("body").off(c.namespace), (n = !1);
                                            });
                                    }
                                }
                                function a(e, t) {
                                    var n = e.parent();
                                    (n.hasClass(r.hasSubDropdownClass) || t) && (n.addClass(r.dropdownActive), (i = !0));
                                }
                                function d() {
                                    l(), h();
                                }
                                function l() {
                                    e(s.navItems).removeClass(r.dropdownActive);
                                }
                                function h() {
                                    e(s.navDropdownLinks).parent().removeClass(r.dropdownActive);
                                }
                                theme.config.isTouch &&
                                    (e(s.navLinksWithDropdown).on("touchend" + c.namespace, function (t) {
                                        var i = e(this),
                                            n = i.parent();
                                        n.hasClass(r.dropdownActive) ? window.location.replace(i.attr("href")) : (t.preventDefault(), d(), o(i));
                                    }),
                                    e(s.navDropdownLinks).on("touchend" + c.namespace, function (t) {
                                        var i = e(this),
                                            n = i.parent();
                                        n.hasClass(r.hasSubDropdownClass) ? (n.hasClass(r.dropdownActive) ? window.location.replace(i.attr("href")) : (t.preventDefault(), h(), a(i))) : window.location.replace(i.attr("href"));
                                    })),
                                    e(s.navLinks).on("focusin mouseover" + c.namespace, function () {
                                        t && l(), i && h(), o(e(this));
                                    }),
                                    e(s.navLinks).on("mouseleave" + c.namespace, function () {
                                        l(), h();
                                    }),
                                    e(s.navDropdownLinks).on("focusin" + c.namespace, function () {
                                        i && h(), a(e(this), !0);
                                    });
                            })(),
                            e(s.searchBtn).on("click" + c.namespace, function (t) {
                                t.preventDefault(),
                                    e(s.searchContainer).addClass("is-active"),
                                    o.addClass("js-drawer-open--search"),
                                    slate.a11y.trapFocus({ $container: e(s.searchContainer), namespace: "header_search", $elementToFocus: e(s.searchContainer).find("input") }),
                                    theme.config.bpSmall && c.stickyEnabled && c.lastScroll < 300 && window.scrollTo(0, 0),
                                    slate.a11y.lockMobileScrolling(c.namespace),
                                    a.on("click" + c.namespace, function () {
                                        return d(), !1;
                                    }),
                                    o.on("keyup" + c.namespace, function (e) {
                                        27 === e.keyCode && d();
                                    });
                            }),
                            e(s.closeSearch).on("click" + c.namespace, function () {
                                d();
                            });
                    },
                    disableOverlayHeader: function () {
                        e(s.wrapper).removeClass(c.stickyEnabledClass).removeClass(c.overlayedClass), e("body").removeClass(r.overlaidBodyClass), (c.wrapperOverlayed = !1);
                    },
                    unload: function () {
                        e(window).off(c.namespace), e(s.searchBtn).off(c.namespace), e(s.closeSearch).off(c.namespace), o.off(c.namespace), e(s.navLinks).off(c.namespace), e(s.navDropdownLinks).off(c.namespace);
                    },
                };
            })()),
            (theme.Slideshow = (function () {
                this.$slideshow = null;
                var t = {
                    next: "is-next",
                    init: "is-init",
                    animateOut: "animate-out",
                    wrapper: "slideshow-wrapper",
                    slideshow: "slideshow",
                    allSlides: "slick-slide",
                    currentSlide: "slick-current",
                    pauseButton: "slideshow__pause",
                    isPaused: "is-paused",
                };
                function i(i, n) {
                    (this.$slideshow = e(i)),
                        (this.$wrapper = this.$slideshow.closest("." + t.wrapper)),
                        (this.$pause = this.$wrapper.find("." + t.pauseButton)),
                        (this.settings = {
                            accessibility: !0,
                            arrows: !!n.arrows,
                            dots: !!n.dots,
                            fade: !!n.fade,
                            speed: n.speed ? n.speed : 500,
                            draggable: !0,
                            touchThreshold: 5,
                            pauseOnHover: !1,
                            autoplay: !!n.autoplay,
                            autoplaySpeed: this.$slideshow.data("speed"),
                        }),
                        this.$slideshow.off("beforeChange"),
                        this.$slideshow.off("afterSlideChange"),
                        this.$slideshow.on("init", this.init.bind(this)),
                        this.$slideshow.on("beforeChange", this.beforeSlideChange.bind(this)),
                        this.$slideshow.on("afterChange", this.afterSlideChange.bind(this)),
                        this.$slideshow.slick(this.settings),
                        this.$pause.on("click", this._togglePause.bind(this));
                }
                return (
                    (i.prototype = e.extend({}, i.prototype, {
                        init: function (e, i) {
                            (this.$slideshowList = i.$list), (this.$slickDots = i.$dots), (this.$allSlides = i.$slides), (this.slideCount = i.slideCount), this.$slideshow.addClass(t.init), this._a11y(), this._clonedLazyloading();
                        },
                        beforeSlideChange: function (e, i, n, o) {
                            i.$slider.find("." + t.currentSlide).addClass(t.animateOut);
                        },
                        afterSlideChange: function (e, i, n) {
                            i.$slider.find("." + t.allSlides).removeClass(t.animateOut);
                        },
                        destroy: function () {
                            this.$slideshow.slick("unslick");
                        },
                        _play: function () {
                            this.$slideshow.slick("slickPause"), e(t.pauseButton).addClass("is-paused");
                        },
                        _pause: function () {
                            this.$slideshow.slick("slickPlay"), e(t.pauseButton).removeClass("is-paused");
                        },
                        _togglePause: function () {
                            var i = this._getSlideshowId(this.$pause);
                            this.$pause.hasClass(t.isPaused) ? (this.$pause.removeClass(t.isPaused), e(i).slick("slickPlay")) : (this.$pause.addClass(t.isPaused), e(i).slick("slickPause"));
                        },
                        _getSlideshowId: function (e) {
                            return "#Slideshow-" + e.data("id");
                        },
                        _activeSlide: function () {
                            return this.$slideshow.find(".slick-active");
                        },
                        _currentSlide: function () {
                            return this.$slideshow.find(".slick-current");
                        },
                        _nextSlide: function (e) {
                            return this.$slideshow.find('.slideshow__slide[data-slick-index="' + e + '"]');
                        },
                        _a11y: function () {
                            var i = this.$slideshowList,
                                n = this.settings.autoplay;
                            i &&
                                (i.removeAttr("aria-live"),
                                e(t.wrapper).on(
                                    "focusin",
                                    function (o) {
                                        e(t.wrapper).has(o.target).length && (i.attr("aria-live", "polite"), n && this._pause());
                                    }.bind(this)
                                ),
                                e(t.wrapper).on(
                                    "focusout",
                                    function (o) {
                                        e(t.wrapper).has(o.target).length && (i.removeAttr("aria-live"), n && this._play());
                                    }.bind(this)
                                ));
                        },
                        _clonedLazyloading: function () {
                            var t = this.$slideshow;
                            t.find(".slick-slide").each(
                                function (i, n) {
                                    var o = e(n);
                                    if (o.hasClass("slick-cloned")) {
                                        var a = o.data("id"),
                                            s = o.find(".hero__image").removeClass("lazyloading").addClass("lazyloaded");
                                        setTimeout(function () {
                                            var e = t.find(".slideshow__slide--" + a + ":not(.slick-cloned) .hero__image").attr("style");
                                            e && s.attr("style", e);
                                        }, this.settings.autoplaySpeed / 1.5);
                                    }
                                }.bind(this)
                            );
                        },
                    })),
                    i
                );
            })()),
            (theme.announcementBar = (function () {
                var t,
                    i = 0,
                    n = !1,
                    o = { accessibility: !0, arrows: !1, dots: !1, autoplay: !0, autoplaySpeed: 5e3, touchThreshold: 20, slidesToShow: 1 };
                function a(e, t) {
                    s(e) && e.slick("unslick"), e.slick(t);
                }
                function s(e) {
                    return e.length && e.hasClass("slick-initialized");
                }
                return {
                    init: function () {
                        if ((t = e("#AnnouncementSlider")).length) {
                            (i = t.data("block-count")), (n = t.data("compact-style"));
                            var s = e.extend({}, o, { slidesToShow: n ? 1 : i, slidesToScroll: 1 }),
                                r = e.extend({}, o, { slidesToShow: 1 });
                            theme.config.bpSmall ? a(t, r) : a(t, s),
                                e("body").on(
                                    "matchSmall",
                                    function () {
                                        a(t, r);
                                    }.bind(this)
                                ),
                                e("body").on(
                                    "matchLarge",
                                    function () {
                                        a(t, s);
                                    }.bind(this)
                                );
                        }
                    },
                    onBlockSelect: function (i) {
                        var n = e("#AnnouncementSlide-" + i);
                        t.length && t.slick("slickPause"), n.length && t.slick("slickGoTo", n.data("index"));
                    },
                    onBlockDeselect: function (e) {
                        t.length && s(t) && t.slick("slickPlay");
                    },
                    unload: function () {
                        s(t) && t.slick("unslick");
                    },
                };
            })()),
            (theme.currencySwitcher = (function () {
                var t,
                    i = { dataDiv: "#CurrencyData", currencyOptions: ".currency-options__btn", pickerFlag: ".currency-picker .currency-flag", pickerLabel: ".currency-picker .currency-picker__label" },
                    n = {};
                function o() {
                    var o = e(this).data("value");
                    if (theme.settings.nativeMultiCurrency) return e(this).addClass("is-active"), void theme.cart.updateCurrency(o);
                    o !== n.currency && ((n.currency = o), e(i.dataDiv).data("current-currency", o), a(o), s()), t.close();
                }
                function a(t) {
                    e(i.pickerFlag).attr("data-flag", t), e(i.pickerLabel).text(t), e(i.currencyOptions).removeClass("is-active"), e(i.currencyOptions + "[data-value=" + t + "]").addClass("is-active");
                }
                function s() {
                    if (!theme.settings.nativeMultiCurrency) {
                        var t = e(i.dataDiv).data("current-currency");
                        Currency.convertAll(Currency.currentCurrency, t);
                    }
                }
                return {
                    init: function () {
                        var s = e(i.dataDiv);
                        s.length &&
                            ((t = new theme.Modals("CurrencyModal", "currency-modal", { closeOffContentClick: !1 })),
                            e(i.currencyOptions).on("click", o),
                            (n = { currency: s.data("shop-currency"), format: s.data("format"), moneyFormat: s.data("money-format"), moneyCurrencyFormat: s.data("money-currency-format") }),
                            theme.settings.nativeMultiCurrency ||
                                ((Currency.format = n.format),
                                (Currency.money_format[n.currency] = n.moneyFormat),
                                (Currency.money_with_currency_format[n.currency] = n.moneyCurrencyFormat),
                                e("span.money span.money").each(function () {
                                    e(this).parents("span.money").removeClass("money");
                                }),
                                e("span.money").each(function () {
                                    e(this).attr("data-currency-" + n.currency, e(this).html());
                                }),
                                (r = Currency.cookie.read()),
                                null == r
                                    ? (Currency.currentCurrency = r = n.currency)
                                    : e(i.currencyOptions).length && 0 === e(i.currencyOptions + "[data-value=" + r + "]").length
                                    ? ((Currency.currentCurrency = n.currency), Currency.cookie.write(n.currency))
                                    : r === n.currency
                                    ? (Currency.currentCurrency = n.currency)
                                    : Currency.convertAll(n.currency, r),
                                e(i.dataDiv).data("current-currency", r),
                                (n.currency = r),
                                a(r)));
                        var r;
                    },
                    refresh: s,
                    ajaxrefresh: function () {
                        if (!theme.settings.nativeMultiCurrency) {
                            var t = e(i.dataDiv).data("shop-currency"),
                                n = e(i.dataDiv).data("current-currency");
                            Currency.convertAll(t, n);
                        }
                    },
                };
            })()),
            (theme.predictiveSearch = (function () {
                var t,
                    i = "",
                    n = !1,
                    o = ".predictive",
                    a = { form: "#HeaderSearchForm", input: 'input[type="search"]', wrapper: ".predictive-results", searchButton: "[data-predictive-search-button]", resultDiv: "#PredictiveResults", resultTemplate: "#PredictiveTemplate" },
                    s = { up_arrow: 38, down_arrow: 40, tab: 9 };
                function r() {
                    e(a.wrapper).addClass("hide"), clearTimeout(t);
                }
                function c() {
                    e(a.form).trigger("submit");
                }
                function d(o) {
                    o.keyCode !== s.up_arrow &&
                        o.keyCode !== s.down_arrow &&
                        o.keyCode !== s.tab &&
                        (function () {
                            var o = e(a.input, a.form).val();
                            if ("" === o) return void r();
                            var s = (function (e) {
                                if ("string" != typeof e) return null;
                                return e.trim().replace(/\ /g, "-").toLowerCase();
                            })(o);
                            clearTimeout(t),
                                (t = setTimeout(
                                    function () {
                                        !(function (t) {
                                            if (n) return;
                                            if (i === t) return;
                                            (i = t),
                                                (n = !0),
                                                jQuery
                                                    .getJSON("/search/suggest.json", {
                                                        q: t,
                                                        resources: { type: theme.settings.predictiveSearchType, limit: 4, options: { unavailable_products: "last", fields: "title,product_type,variants.title,vendor" } },
                                                    })
                                                    .done(function (t) {
                                                        n = !1;
                                                        var i = {},
                                                            o = 0;
                                                        e(a.wrapper).removeClass("hide");
                                                        for (var s = Object.entries(t.resources.results), c = s.length - 1; c >= 0; c--) {
                                                            var d = s[c],
                                                                u = d[0],
                                                                p = d[1];
                                                            switch (((o += p.length), u)) {
                                                                case "products":
                                                                    i[u] = l(p);
                                                                    break;
                                                                default:
                                                                    i[u] = h(p);
                                                            }
                                                        }
                                                        0 === o && r(), e(a.resultDiv).empty().append(resultTemplate(i));
                                                    });
                                        })(s);
                                    }.bind(this),
                                    500
                                ));
                        })();
                }
                function l(e) {
                    for (var t = [], i = e.length - 1; i >= 0; i--) {
                        var n = e[i],
                            o = {
                                title: n.title,
                                url: n.url,
                                image: theme.Images.lazyloadImagePath(n.image),
                                vendor: n.vendor,
                                price: theme.Currency.formatMoney(n.price),
                                compare_price_max: theme.Currency.formatMoney(n.compare_at_price_max),
                                on_sale: parseInt(n.compare_at_price_max) > parseInt(n.price),
                                custom_label: u(n.tags),
                            };
                        t.push(o);
                    }
                    return t;
                }
                function h(e) {
                    for (var t = e.length - 1; t >= 0; t--)
                        if (e[t].image) {
                            var i = theme.Images.lazyloadImagePath(e[t].image);
                            e[t].image = i;
                        }
                    return e;
                }
                function u(e) {
                    if (!e.length) return !1;
                    for (var t = e.length - 1; t >= 0; t--) if (-1 !== e[t].indexOf("_label_")) return e[t].replace("_label_", "");
                    return !1;
                }
                return {
                    init: function () {
                        if (document.getElementById("shopify-features") && !JSON.parse(document.getElementById("shopify-features").innerHTML).predictiveSearch) return;
                        e(a.form).attr("autocomplete", "off"), e(a.input, a.form).on("keyup" + o, d), e(a.searchButton, a.wrapper).on("click" + o, c);
                        var t = e(a.resultTemplate).html();
                        resultTemplate = Handlebars.compile(t);
                    },
                };
            })()),
            (theme.initQuickShop = function (t) {
                var i = [];
                e(".quick-product__btn").each(function () {
                    var t = e(this).data("product-id"),
                        n = "QuickShopModal-" + t,
                        o = "quick-modal-" + t;
                    i.indexOf(t) > -1
                        ? e('.modal--quick-shop[data-product-id="' + t + '"]').each(function (t) {
                              t > 0 && e(this).remove();
                          })
                        : (new theme.Modals(n, o), i.push(t));
                });
            }),
            (theme.videoModal = function () {
                var t = {
                        width: 1280,
                        height: 720,
                        playerVars: { autohide: 0, autoplay: 1, branding: 0, cc_load_policy: 0, fs: 0, iv_load_policy: 3, modestbranding: 1, playsinline: 1, quality: "hd720", rel: 0, showinfo: 0, wmode: "opaque" },
                    },
                    i = 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]';
                if (e(i).length) {
                    var n = new theme.Modals("VideoModal", "video-modal", { closeOffContentClick: !0, solid: !0 });
                    e(i).on("click", function (t) {
                        t.preventDefault(),
                            window.loadYouTube(),
                            theme.config.youTubeReady
                                ? o(t)
                                : e("body").on("youTubeReady", function () {
                                      o(t);
                                  });
                    });
                }
                function o(i) {
                    var o,
                        a,
                        s = e(i.currentTarget),
                        r = ((o = s.attr("href")), !(!(a = o.match(/^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/)) || 11 != a[7].length) && a[7]),
                        c = e.extend({}, t, { videoId: r });
                    c.playerVars.playsinline = theme.config.bpSmall ? 0 : 1;
                    var d = new YT.Player("VideoHolder", c);
                    n.open(),
                        e("body").on("modalClose.VideoModal", function () {
                            setTimeout(function () {
                                d.destroy();
                            }, 500);
                        });
                }
            }),
            (theme.RecentlyViewed = (function () {
                var t = { template: "#RecentlyViewedProduct", outputContainer: "#RecentlyViewed-" },
                    i = !1;
                function n(i) {
                    var n = (this.$container = e(i)),
                        o = (this.sectionId = n.attr("data-section-id"));
                    (this.namespace = ".recently-viewed" + o), e(t.template).length && (this.checkVisibility(), e(window).on("scroll" + this.namespace, e.throttle(200, this.checkVisibility.bind(this))));
                }
                return (
                    (n.prototype = e.extend({}, n.prototype, {
                        init: function () {
                            if (!i && ((i = !0), !e.isEmptyObject(theme.recentlyViewed.recent))) {
                                (this.outputContainer = e(t.outputContainer + this.sectionId)), (this.handle = this.$container.attr("data-product-handle"));
                                var n = [];
                                for (handle in theme.recentlyViewed.recent) n.push(this.getProductInfo(handle));
                                Promise.all(n).then(
                                    function (e) {
                                        this.setupOutput(e), this.captureProductDetails(e);
                                    }.bind(this),
                                    function (e) {
                                        console.warn("Theme | recently viewed products failed to load");
                                    }
                                );
                            }
                        },
                        checkVisibility: function () {
                            theme.isElementVisible(this.$container, 600) && (this.init(), e(window).off("scroll" + this.namespace));
                        },
                        getProductInfo: function (e) {
                            return new Promise(function (t, i) {
                                theme.recentlyViewed.productInfo.hasOwnProperty(e)
                                    ? t(theme.recentlyViewed.productInfo[e])
                                    : jQuery.getJSON("/products/" + e + ".js", function (e) {
                                          t(e);
                                      });
                            });
                        },
                        setupOutput: function (i) {
                            var n,
                                o = [],
                                a = this.$container.attr("data-recent-count");
                            for (key in i) {
                                var s = i[key];
                                s.handle !== this.handle &&
                                    (0,
                                    (s.url_formatted = theme.recentlyViewed.recent[s.handle] ? theme.recentlyViewed.recent[s.handle].url : s.url),
                                    (s.image_responsive_url = theme.recentlyViewed.recent[s.handle].featuredImage),
                                    (s.image_aspect_ratio = theme.recentlyViewed.recent[s.handle].aspectRatio),
                                    (s.on_sale = s.compare_at_price > s.price),
                                    (s.sold_out = !s.available),
                                    (s.price_formatted = theme.Currency.formatMoney(s.price, theme.settings.moneyFormat)),
                                    (s.compare_at_price_formatted = theme.Currency.formatMoney(s.compare_at_price, theme.settings.moneyFormat)),
                                    (s.price_min_formatted = theme.Currency.formatMoney(s.price_min, theme.settings.moneyFormat)),
                                    (s.money_saved = theme.Currency.formatMoney(s.compare_at_price - s.price, theme.settings.moneyFormat)),
                                    o.unshift(s));
                            }
                            if (((n = { items: o.slice(0, a), grid_item_width: this.$container.attr("data-grid-item-class") }), 0 !== o.length)) {
                                var r = e(t.template).html(),
                                    c = Handlebars.compile(r);
                                this.outputContainer.append(c(n)), AOS && AOS.refreshHard();
                            }
                        },
                        captureProductDetails: function (e) {
                            for (var t = 0; t < e.length; t++) {
                                var i = e[t];
                                theme.recentlyViewed.productInfo[i.handle] = i;
                            }
                            theme.config.hasSessionStorage && sessionStorage.setItem("recent-products", JSON.stringify(theme.recentlyViewed.productInfo));
                        },
                        onUnload: function () {
                            (i = !1), e("window").off(this.namespace);
                        },
                    })),
                    n
                );
            })()),
            (theme.parallaxSections = {}),
            (theme.Parallax = (function () {
                function t(t, i) {
                    (this.$container = e(t)), (this.namespace = i.namespace), this.$container.length && (i.desktopOnly ? this.desktopInit() : this.init(this.$container, i));
                }
                return (
                    (t.prototype = e.extend({}, t.prototype, {
                        init: function (t) {
                            var i = (this.$window = e(window)),
                                n = this.$container.offset().top;
                            i.on(
                                "scroll" + this.namespace,
                                function (e) {
                                    var t = i.scrollTop(),
                                        o = (n - t) / 7;
                                    this.$container.css({ transform: "translate3d(0, " + o + "px, 0)" });
                                }.bind(this)
                            ),
                                i.on(
                                    "resize" + this.namespace,
                                    e.debounce(
                                        350,
                                        function () {
                                            i.off(this.namespace), !t || theme.config.bpSmall ? this.init() : this.init(!0);
                                        }.bind(this)
                                    )
                                );
                        },
                        desktopInit: function () {
                            theme.config.bpSmall || this.init(!0),
                                e("body").on(
                                    "matchSmall",
                                    function () {
                                        this.destroy();
                                    }.bind(this)
                                ),
                                e("body").on(
                                    "matchLarge",
                                    function () {
                                        this.init(!0);
                                    }.bind(this)
                                );
                        },
                        destroy: function () {
                            this.$container.removeAttr("style"), this.$window.off(this.namespace);
                        },
                    })),
                    t
                );
            })()),
            (theme.collectionTemplate = (function () {
                var t = !1,
                    i = { collectionGrid: ".collection-grid__wrapper", sidebar: "#CollectionSidebar", activeTagList: ".tag-list--active-tags", tags: ".tag-list a", filters: ".collection-filter" },
                    n = { combineTags: e(i.sidebar).data("combine-tags") },
                    o = { activeTag: "tag--active", removeTagParent: "tag--remove" };
                function a(t) {
                    var i;
                    ((i = theme.config.bpSmall ? e("[data-scroll-to]").offset().top - 60 : e("#CollectionAjaxResult").offset().top + 1), theme.config.stickyHeader) && (i -= e(".site-header").outerHeight(!0));
                    t ? e("html, body").animate({ scrollTop: i }, 300) : e("html, body").scrollTop(i);
                }
                function s() {
                    var t = e(".site-header").outerHeight(!0);
                    e(i.filters).css("top", t + 10);
                }
                function r(i) {
                    (i += "?view=ajax"),
                        e("#CollectionAjaxResult").load(
                            i + " #CollectionAjaxContent",
                            function () {
                                (t = !1), theme.reinitSection("collection-template"), theme.collectionTemplate.reinit();
                            }.bind(this)
                        );
                }
                return {
                    init: function () {
                        e(window).on("popstate", function (e) {
                            e && r(location.href);
                        }),
                            theme.config.stickyHeader && (s(), e(window).on("resize", e.debounce(150, s))),
                            e("body").on("click", i.tags, function (s) {
                                var c = e(this);
                                if ((theme.FilterDrawer && theme.FilterDrawer.close(), !c.hasClass("no-ajax") && (s.preventDefault(), !t))) {
                                    t = !0;
                                    var c = e(s.currentTarget),
                                        d = c.parent(),
                                        l = c.attr("href");
                                    n.combineTags
                                        ? d.hasClass(o.activeTag)
                                            ? d.removeClass(o.activeTag)
                                            : (d.addClass(o.activeTag),
                                              c.parent("li").hasClass(o.removeTagParent)
                                                  ? e(this).parent().remove()
                                                  : e(i.activeTagList).append('<li class="tag tag--remove"><a class="btn btn--small js-no-transition">' + c.text() + "</a></li>"))
                                        : (e(i.tags).parent().removeClass(o.activeTag), d.addClass(o.activeTag)),
                                        a(!0),
                                        history.pushState({}, "", l),
                                        e(i.collectionGrid).addClass("unload"),
                                        r(l);
                                }
                            });
                    },
                    reinit: function () {
                        (n.combineTags = e(i.sidebar).data("combine-tags")), a(!1), theme.pageTransitions(), theme.reinitProductGridItem(), e("body").trigger("resize");
                    },
                };
            })()),
            (theme.customerTemplates = (function () {
                function t() {
                    e("#RecoverPasswordForm").toggleClass("hide"), e("#CustomerLoginForm").toggleClass("hide");
                }
                return {
                    init: function () {
                        var i, n;
                        "#recover" === window.location.hash && t(),
                            e("#RecoverPassword").on("click", function (e) {
                                e.preventDefault(), t();
                            }),
                            e("#HideRecoverPasswordLink").on("click", function (e) {
                                e.preventDefault(), t();
                            }),
                            e(".reset-password-success").length && e("#ResetSuccess").removeClass("hide"),
                            (i = e("#AddressNewForm")),
                            (n = e(".js-address-form")),
                            i.length &&
                                n.length &&
                                (Shopify &&
                                    e(".js-address-country").each(function () {
                                        var t = e(this),
                                            i = t.data("country-id"),
                                            n = t.data("province-id"),
                                            o = t.data("province-container-id");
                                        new Shopify.CountryProvinceSelector(i, n, { hideElement: o });
                                    }),
                                e(".address-new-toggle").on("click", function () {
                                    i.toggleClass("hide");
                                }),
                                e(".address-edit-toggle").on("click", function () {
                                    var t = e(this).data("form-id");
                                    e("#EditAddress_" + t).toggleClass("hide");
                                }),
                                e(".address-delete").on("click", function () {
                                    var t = e(this),
                                        i = t.data("form-id"),
                                        n = t.data("confirm-message");
                                    confirm(n || "Are you sure you wish to delete this address?") && Shopify.postLink("/account/addresses/" + i, { parameters: { _method: "delete" } });
                                }));
                    },
                };
            })()),
            (theme.Product = (function () {
                var t,
                    i,
                    n = { onSale: "on-sale", disabled: "disabled", isModal: "is-modal", loading: "loading", loaded: "loaded", interactable: "video-interactable", visuallyHide: "visually-invisible" },
                    o = { productVideo: ".product__video", videoParent: ".product__video-wrapper", currentSlide: ".slick-current" },
                    a = {},
                    s = [],
                    r = {
                        height: "480",
                        width: "850",
                        playerVars: { autohide: 0, autoplay: 1, branding: 0, cc_load_policy: 0, controls: 0, fs: 0, iv_load_policy: 3, modestbranding: 1, playsinline: 1, quality: "hd720", rel: 0, showinfo: 0, wmode: "opaque" },
                        events: {
                            onReady: function (t) {
                                var i = e(t.target.a),
                                    n = i.attr("id");
                                s[n] = t.target;
                                s[n];
                                u(i), "muted" === a[n].style ? s[n].mute().playVideo().pauseVideo() : p(i);
                                (i.closest(o.currentSlide).length || 1 === i.data("image-count")) && "muted" === a[n].style && (s[n].playVideo(), l(n));
                            },
                            onStateChange: function (t) {
                                var i = e(t.target.a),
                                    r = i.attr("id"),
                                    c = s[r];
                                switch (t.data) {
                                    case -1:
                                        a[r].attemptedToPlay && (p(i), i.closest(o.videoParent).addClass(n.interactable));
                                        break;
                                    case 0:
                                        c.playVideo();
                                        break;
                                    case 1:
                                        p(i);
                                        break;
                                    case 3:
                                        a[r].attemptedToPlay = !0;
                                }
                            },
                        },
                    },
                    c = [],
                    d = { byline: !1, title: !1, portrait: !1, loop: !0 };
                function l(t) {
                    h(t), e(window).on("scroll." + t, { id: t }, e.throttle(150, h));
                }
                function h(t) {
                    var i;
                    if (((i = "string" == typeof t ? t : t.data.id), theme.isElementVisible(e("#" + i)))) {
                        if (a[i] && "unmuted" === a[i].style) return;
                        !(function (e) {
                            s[e] && "function" == typeof s[e].playVideo && s[e].playVideo();
                        })(i);
                    } else
                        !(function (e) {
                            s[e] && "function" == typeof s[e].pauseVideo && s[e].pauseVideo();
                        })(i);
                }
                function u(e) {
                    e.closest(o.videoParent).addClass(n.loading);
                }
                function p(e) {
                    e.closest(o.videoParent).removeClass(n.loading).addClass(n.loaded);
                }
                function m(t) {
                    var i = (this.$container = e(t)),
                        n = (this.sectionId = i.attr("data-section-id"));
                    (this.inModal = i.closest(".modal").length),
                        this.$modal,
                        (this.settings = {
                            enableHistoryState: i.data("enable-history-state") || !1,
                            namespace: ".product-" + n,
                            inventory: i.data("inventory") || !1,
                            incomingInventory: i.data("incoming-inventory") || !1,
                            modalInit: !1,
                            lazyLoadModalContent: i.data("lazyload-content") || !1,
                            slickMainInitialized: !1,
                            slickThumbInitialized: !1,
                            thumbArrows: !1,
                            thumbVertical: !1,
                            hasImages: !0,
                            hasMultipleImages: !1,
                            imageSize: "620x",
                        }),
                        this.inModal && ((this.settings.enableHistoryState = !1), (this.settings.namespace = ".product-" + n + "-modal"), (this.$modal = e("#QuickShopModal-" + n))),
                        (this.selectors = {
                            variantsJson: "VariantsJson-" + n,
                            currentVariantJson: "CurrentVariantJson-" + n,
                            video: "ProductVideo-" + n,
                            photoThumbs: ".product__thumb-" + n,
                            thumbSlider: "#ProductThumbs-" + n,
                            mainSlider: "#ProductPhotos-" + n,
                            imageContainer: "[data-product-images]",
                            productImageMain: ".product-image-main--" + n,
                            priceWrapper: ".product__price-wrap-" + n,
                            price: "#ProductPrice-" + n,
                            comparePrice: "#ComparePrice-" + n,
                            savePrice: "#SavePrice-" + n,
                            priceA11y: "#PriceA11y-" + n,
                            comparePriceA11y: "#ComparePriceA11y-" + n,
                            unitWrapper: ".product__unit-price-wrapper--" + n,
                            unitPrice: ".product__unit-price--" + n,
                            unitPriceBaseUnit: ".product__unit-base--" + n,
                            sku: "#Sku-" + n,
                            inventory: "#ProductInventory-" + n,
                            incomingInventory: "#ProductIncomingInventory-" + n,
                            addToCart: "#AddToCart-" + n,
                            addToCartText: "#AddToCartText-" + n,
                            originalSelectorId: "#ProductSelect-" + n,
                            singleOptionSelector: ".variant__input-" + n,
                            variantColorSwatch: ".variant__input--color-swatch-" + n,
                            modalFormHolder: "#ProductFormHolder-" + n,
                            formContainer: "#AddToCartForm-" + n,
                        }),
                        (this.$mainSlider = e(this.selectors.mainSlider)),
                        (this.$thumbSlider = e(this.selectors.thumbSlider)),
                        (this.$firstProductImage = this.$mainSlider.find("img").first()),
                        this.$firstProductImage.length || (this.settings.hasImages = !1),
                        this.init();
                }
                return (
                    (m.prototype = e.extend({}, m.prototype, {
                        init: function () {
                            this.inModal &&
                                (this.$container.addClass(n.isModal),
                                e("body")
                                    .off("modalOpen.QuickShopModal-" + this.sectionId)
                                    .off("modalClose.QuickShopModal-" + this.sectionId),
                                e("body").on("modalOpen.QuickShopModal-" + this.sectionId, this.openModalProduct.bind(this)),
                                e("body").on("modalClose.QuickShopModal-" + this.sectionId, this.closeModalProduct.bind(this))),
                                this.inModal || (this.stringOverrides(), this.formSetup(), this.productSetup(), this.checkIfVideos(), this.createImageCarousels(), this.addIdToRecentlyViewed());
                        },
                        formSetup: function () {
                            theme.settings.dynamicVariantsEnable && (this.$variantSelectors = e(this.selectors.formContainer).find(this.selectors.singleOptionSelector)),
                                this.initQtySelector(),
                                this.initAjaxProductForm(),
                                this.initVariants();
                        },
                        productSetup: function () {
                            this.setImageSizes(), this.initImageSwitch(), this.initImageZoom();
                        },
                        addIdToRecentlyViewed: function () {
                            var e = this.$container.attr("data-product-handle"),
                                t = this.$container.attr("data-product-url"),
                                i = this.$container.attr("data-aspect-ratio"),
                                n = this.$container.attr("data-img-url");
                            theme.recentlyViewed.recent.hasOwnProperty(e) && delete theme.recentlyViewed.recent[e],
                                (theme.recentlyViewed.recent[e] = { url: t, aspectRatio: i, featuredImage: n }),
                                Cookies.set("theme-recent", JSON.stringify(theme.recentlyViewed.recent), { path: "/", expires: 1e4 });
                        },
                        initImageZoom: function () {
                            var t = e(this.selectors.imageContainer, this.$container);
                            new theme.Photoswipe(t[0], this.sectionId);
                        },
                        stringOverrides: function () {
                            (theme.productStrings = theme.productStrings || {}), e.extend(theme.strings, theme.productStrings);
                        },
                        setImageSizes: function () {
                            if (this.settings.hasImages) {
                                var e = this.$firstProductImage[0].currentSrc;
                                e && (this.settings.imageSize = theme.Images.imageSize(e));
                            }
                        },
                        initVariants: function () {
                            if (document.getElementById(this.selectors.variantsJson)) {
                                this.variantsObject = JSON.parse(document.getElementById(this.selectors.variantsJson).innerHTML);
                                var t = {
                                    $container: this.$container,
                                    enableHistoryState: this.settings.enableHistoryState,
                                    singleOptionSelector: this.selectors.singleOptionSelector,
                                    originalSelectorId: this.selectors.originalSelectorId,
                                    variants: this.variantsObject,
                                };
                                e(this.selectors.variantColorSwatch).length &&
                                    e(this.selectors.variantColorSwatch).on(
                                        "change",
                                        function (t) {
                                            var i = e(t.currentTarget),
                                                n = i.data("color-name"),
                                                o = i.data("color-index");
                                            this.updateColorName(n, o);
                                        }.bind(this)
                                    ),
                                    (this.variants = new slate.Variants(t)),
                                    this.$container
                                        .on("variantChange" + this.settings.namespace, this.updateCartButton.bind(this))
                                        .on("variantImageChange" + this.settings.namespace, this.updateVariantImage.bind(this))
                                        .on("variantPriceChange" + this.settings.namespace, this.updatePrice.bind(this))
                                        .on("variantUnitPriceChange" + this.settings.namespace, this.updateUnitPrice.bind(this)),
                                    e(this.selectors.sku).length && this.$container.on("variantSKUChange" + this.settings.namespace, this.updateSku.bind(this)),
                                    (this.settings.inventory || this.settings.incomingInventory) && this.$container.on("variantChange" + this.settings.namespace, this.updateInventory.bind(this)),
                                    theme.settings.dynamicVariantsEnable &&
                                        document.getElementById(this.selectors.currentVariantJson) &&
                                        ((this.currentVariantObject = JSON.parse(document.getElementById(this.selectors.currentVariantJson).innerHTML)),
                                        this.$variantSelectors.on("change" + this.settings.namespace, this.updateVariantAvailability.bind(this)),
                                        this.setCurrentVariantAvailability(this.currentVariantObject, !0));
                            }
                        },
                        setCurrentVariantAvailability: function (t) {
                            var i = { option1: [], option2: [], option3: [] };
                            this.disableVariantGroup(e(this.selectors.formContainer).find(".variant-input-wrap"));
                            var n = this.variantsObject.filter(function (e) {
                                    return t.id !== e.id && ((t.option2 === e.option2 && t.option3 === e.option3) || (t.option1 === e.option1 && t.option3 === e.option3) || (t.option1 === e.option1 && t.option2 === e.option2) || void 0);
                                }),
                                o = { variant: t };
                            for (var a in (n = Object.assign({}, o, n)))
                                if (n.hasOwnProperty(a)) {
                                    var s = n[a],
                                        r = s.option1,
                                        c = s.option2,
                                        d = s.option3;
                                    r && -1 === i.option1.indexOf(r) && i.option1.push(r), c && -1 === i.option2.indexOf(c) && i.option2.push(c), d && -1 === i.option3.indexOf(d) && i.option3.push(d);
                                }
                            i.option1.length && this.enableVariantOptionByValue(i.option1, "option1"),
                                i.option2.length && this.enableVariantOptionByValue(i.option2, "option2"),
                                i.option3.length && this.enableVariantOptionByValue(i.option3, "option3");
                        },
                        updateVariantAvailability: function (t, i, n) {
                            if (i && n)
                                var o = i,
                                    a = n;
                            else {
                                var s = e(t.currentTarget);
                                (o = s.val() ? s.val() : t.currentTarget.value), (a = s.data("index"));
                            }
                            var r = this.variantsObject.filter(function (e) {
                                return e[a] === o;
                            });
                            e(this.selectors.formContainer)
                                .find(".variant-input-wrap")
                                .each(
                                    function (t, i) {
                                        var n = e(i),
                                            o = n.data("index");
                                        if (o !== a) {
                                            this.disableVariantGroup(n);
                                            for (var s = 0; s < r.length; s++) this.enableVariantOption(n, r[s][o]);
                                        }
                                    }.bind(this)
                                );
                        },
                        disableVariantGroup: function (e) {
                            "dropdown" === theme.settings.dynamicVariantType ? e.find("option").prop("disabled", !0) : (e.find("input").prop("disabled", !0), e.find("label").toggleClass("disabled", !0));
                        },
                        enableVariantOptionByValue: function (t, i) {
                            for (var n = e(this.selectors.formContainer).find('.variant-input-wrap[data-index="' + i + '"]'), o = 0; o < t.length; o++) this.enableVariantOption(n, t[o]);
                        },
                        enableVariantOption: function (e, t) {
                            if (((t = t.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, "\\$1")), "dropdown" === theme.settings.dynamicVariantType)) e.find('option[value="' + t + '"]').prop("disabled", !1);
                            else {
                                var i = e.find('.variant-input[data-value="' + t + '"]');
                                i.find("input").prop("disabled", !1), i.find("label").toggleClass("disabled", !1);
                            }
                        },
                        updateColorName: function (t, i) {
                            e("#VariantColorLabel-" + this.sectionId + "-" + i).text(t);
                        },
                        updateCartButton: function (t) {
                            var i = t.variant;
                            i
                                ? i.available
                                    ? (e(this.selectors.addToCart).removeClass(n.disabled).prop("disabled", !1), e(this.selectors.addToCartText).html(theme.strings.addToCart))
                                    : (e(this.selectors.addToCart).addClass(n.disabled).prop("disabled", !0), e(this.selectors.addToCartText).html(theme.strings.soldOut))
                                : (e(this.selectors.addToCart).addClass(n.disabled).prop("disabled", !0), e(this.selectors.addToCartText).html(theme.strings.unavailable));
                        },
                        updatePrice: function (t) {
                            var i = t.variant;
                            if (i) {
                                if ((e(this.selectors.price).html(theme.Currency.formatMoney(i.price, theme.settings.moneyFormat)).show(), i.compare_at_price > i.price)) {
                                    e(this.selectors.comparePrice).html(theme.Currency.formatMoney(i.compare_at_price, theme.settings.moneyFormat)),
                                        e(this.selectors.priceWrapper).removeClass("hide"),
                                        e(this.selectors.price).addClass(n.onSale),
                                        e(this.selectors.comparePriceA11y).attr("aria-hidden", "false"),
                                        e(this.selectors.priceA11y).attr("aria-hidden", "false");
                                    var o = i.compare_at_price - i.price;
                                    (o = "percent" == theme.settings.saveType ? Math.round((100 * o) / i.compare_at_price) + "%" : theme.Currency.formatMoney(o, theme.settings.moneyFormat)),
                                        e(this.selectors.savePrice).removeClass("hide").html(theme.strings.savePrice.replace("[saved_amount]", o));
                                } else
                                    e(this.selectors.priceWrapper).addClass("hide"),
                                        e(this.selectors.price).removeClass(n.onSale),
                                        e(this.selectors.comparePriceA11y).attr("aria-hidden", "true"),
                                        e(this.selectors.priceA11y).attr("aria-hidden", "true"),
                                        e(this.selectors.savePrice).addClass("hide");
                                theme.settings.currenciesEnabled && theme.currencySwitcher.ajaxrefresh();
                            }
                        },
                        updateUnitPrice: function (t) {
                            var i = t.variant;
                            i && i.unit_price
                                ? (e(this.selectors.unitPrice).html(theme.Currency.formatMoney(i.unit_price, theme.settings.moneyFormat)),
                                  e(this.selectors.unitPriceBaseUnit).text(theme.Currency.getBaseUnit(i)),
                                  e(this.selectors.unitWrapper).removeClass("hide").removeClass(n.visuallyHide))
                                : e(this.selectors.unitWrapper).addClass(n.visuallyHide);
                        },
                        updateSku: function (t) {
                            var i = t.variant,
                                n = "";
                            i && (i.sku && (n = i.sku), e(this.selectors.sku).html(n));
                        },
                        updateInventory: function (e) {
                            var t = e.variant;
                            if (!t || !t.inventory_management) return this.toggleInventoryQuantity(!1), void this.toggleIncomingInventory(!1);
                            if ("shopify" === t.inventory_management && window.inventories && window.inventories[this.sectionId]) {
                                variantInventoryObject = window.inventories[this.sectionId][t.id];
                                var i = variantInventoryObject.quantity,
                                    n = !0,
                                    o = !1;
                                (i <= 0 || i > theme.settings.inventoryThreshold) && (n = !1),
                                    this.toggleInventoryQuantity(n, i),
                                    !n && variantInventoryObject.incoming && (o = !0),
                                    this.toggleIncomingInventory(o, t.available, variantInventoryObject.next_incoming_date);
                            }
                        },
                        toggleInventoryQuantity: function (t, i) {
                            this.settings.inventory || (t = !1), t ? e(this.selectors.inventory).removeClass("hide").text(theme.strings.stockLabel.replace("[count]", i)) : e(this.selectors.inventory).addClass("hide");
                        },
                        toggleIncomingInventory: function (t, i, n) {
                            if ((this.settings.incomingInventory || (t = !1), t)) {
                                var o = i ? theme.strings.willNotShipUntil.replace("[date]", n) : theme.strings.willBeInStockAfter.replace("[date]", n);
                                n || (o = theme.strings.waitingForStock), e(this.selectors.incomingInventory).removeClass("hide").text(o);
                            } else e(this.selectors.incomingInventory).addClass("hide");
                        },
                        updateVariantImage: function (t) {
                            var i = t.variant,
                                n = (theme.Images.getSizedImageUrl(i.featured_image.src, this.settings.imageSize), e('.product__thumb[data-id="' + i.featured_image.id + '"]')),
                                o = this._slideIndex(n.closest(".product__thumb-item"));
                            void 0 !== o && this.$mainSlider.slick("slickGoTo", o);
                        },
                        initImageSwitch: function () {
                            if (e(this.selectors.photoThumbs).length) {
                                e(this.selectors.photoThumbs).on("click", function (e) {
                                    e.preventDefault();
                                });
                            }
                        },
                        checkIfVideos: function () {
                            var t = this.$mainSlider.find(o.productVideo);
                            if (!t.length) return !1;
                            var n = [];
                            return (
                                t.each(function () {
                                    var t = e(this).data("video-type");
                                    n.indexOf(t) < 0 && n.push(t);
                                }),
                                n.indexOf("youtube") > -1 &&
                                    (theme.config.youTubeReady
                                        ? this.loadYoutubeVideos(t)
                                        : (window.loadYouTube(),
                                          e("body").on(
                                              "youTubeReady" + this.settings.namespace,
                                              function () {
                                                  this.loadYoutubeVideos(t);
                                              }.bind(this)
                                          ))),
                                n.indexOf("vimeo") > -1 &&
                                    (i
                                        ? this.loadVimeoVideos(t)
                                        : (window.loadVimeo(),
                                          e("body").on(
                                              "vimeoReady" + this.settings.namespace,
                                              function () {
                                                  this.loadVimeoVideos(t);
                                              }.bind(this)
                                          ))),
                                n.indexOf("mp4") > -1 && this.loadMp4Videos(t),
                                n
                            );
                        },
                        loadMp4Videos: function (t) {
                            t.each(function () {
                                var t = e(this);
                                if ("mp4" == t.data("video-type")) {
                                    var i = t.attr("id");
                                    t.data("video-id");
                                    a[this.id] = { type: "mp4", divId: i, style: t.data("video-style") };
                                }
                            });
                        },
                        loadVimeoVideos: function (t) {
                            for (var n in (t.each(function () {
                                var t = e(this);
                                if ("vimeo" == t.data("video-type")) {
                                    var i = t.attr("id"),
                                        n = t.data("video-id");
                                    a[this.id] = { type: "vimeo", divId: i, id: n, style: t.data("video-style"), width: t.data("video-width"), height: t.data("video-height") };
                                }
                            }),
                            a))
                                if ("vimeo" == a[n].type) {
                                    var o = e.extend({}, d, a[n]);
                                    c[n] = new Vimeo.Player(a[n].divId, o);
                                }
                            i = !0;
                        },
                        autoplayVimeoVideo: function (t) {
                            theme.config.bpSmall ? p(e("#" + t)) : this.requestToPlayVimeoVideo(t);
                        },
                        requestToPlayVimeoVideo: function (t) {
                            u(e("#" + t)),
                                i
                                    ? this.playVimeoVideo(t)
                                    : e("body").on(
                                          "vimeoReady" + this.settings.namespace,
                                          function () {
                                              this.playVimeoVideo(t);
                                          }.bind(this)
                                      );
                        },
                        playVimeoVideo: function (t) {
                            c[t].play(), "muted" === a[t].style && c[t].setVolume(0), p(e("#" + t));
                        },
                        stopVimeoVideo: function (e) {
                            if (theme.config.vimeoReady)
                                if (e) c[e].pause();
                                else for (key in c) "function" == typeof c[key].pause && c[key].pause();
                        },
                        loadYoutubeVideos: function (i) {
                            for (var n in (i.each(function () {
                                var t = e(this);
                                if ("youtube" == t.data("video-type")) {
                                    var i = t.attr("id"),
                                        n = t.data("youtube-id");
                                    a[this.id] = { type: "youtube", id: i, videoId: n, style: t.data("video-style"), width: t.data("video-width"), height: t.data("video-height"), attemptedToPlay: !1 };
                                }
                            }),
                            a))
                                if ("youtube" === a[n].type && a.hasOwnProperty(n)) {
                                    var o = e.extend({}, r, a[n]);
                                    "muted" === o.style || ((o.playerVars.controls = 1), (o.playerVars.autoplay = 0)), (s[n] = new YT.Player(n, o));
                                }
                            t = !0;
                        },
                        requestToPlayYoutubeVideo: function (t, i) {
                            if (theme.config.youTubeReady)
                                if ((u(e("#" + t)), "function" == typeof s[t].playVideo)) this.playYoutubeVideo(t, i);
                                else {
                                    var n = this;
                                    setTimeout(function () {
                                        n.playYoutubeVideo(t, i);
                                    }, 1e3);
                                }
                        },
                        playYoutubeVideo: function (t, i) {
                            p(e("#" + t)), "function" == typeof s[t].playVideo && s[t].playVideo(), i || l(t);
                        },
                        stopYoutubeVideo: function (t) {
                            if (theme.config.youTubeReady)
                                if (t && s[t]) "function" == typeof s[t].pauseVideo && s[t].pauseVideo(), e(window).off("scroll." + t);
                                else for (key in s) "function" == typeof s[key].pauseVideo && (s[key].pauseVideo(), e(window).off("scroll." + key));
                        },
                        playMp4Video: function (t) {
                            var i = e("#" + t);
                            p(i);
                            var n = i[0].play();
                            void 0 !== n &&
                                n
                                    .then(function () {})
                                    .catch(function (e) {
                                        i[0].setAttribute("controls", ""), i.closest(o.videoParent).attr("data-video-style", "unmuted");
                                    });
                        },
                        stopMp4Video: function (t) {
                            if (t) e("#" + t)[0].pause();
                            else
                                for (var i in a)
                                    if ("mp4" === a[i].type) {
                                        var n = e("#" + a[i].divId)[0];
                                        "function" == typeof n.pause && n.pause();
                                    }
                        },
                        createImageCarousels: function () {
                            if (!this.$thumbSlider.length || e(this.selectors.photoThumbs).length < 2) {
                                var t = e(this.selectors.productImageMain).find(o.productVideo);
                                t.length && this.initVideo(t);
                            } else {
                                this.settings.hasMultipleImages = !0;
                                var i = this.$mainSlider.find(".starting-slide"),
                                    n = this._slideIndex(i);
                                this.$mainSlider.off("init"),
                                    this.$mainSlider.off("beforeChange"),
                                    this.$mainSlider.on("init", this.mainSlideInit.bind(this)),
                                    this.$mainSlider.on("beforeChange", this.beforeSlideChange.bind(this)),
                                    this.$thumbSlider.on("init", this.thumbSlideInit.bind(this)),
                                    (this.mainSliderArgs = { infinite: !0, arrows: !1, dots: !0, adaptiveHeight: !0, initialSlide: n }),
                                    (this.thumbSliderArgs = { initialSlide: n });
                                var a = this.setSliderArgs();
                                this.initSliders(a),
                                    e("body").on(
                                        "matchSmall matchLarge",
                                        function () {
                                            var e = this.setSliderArgs();
                                            this.initSliders(e);
                                        }.bind(this)
                                    ),
                                    AOS && AOS.refresh();
                            }
                        },
                        initSliders: function (e) {
                            this.destroyImageCarousels(), this.$mainSlider.slick(e.main), theme.config.bpSmall || this.$thumbSlider.slick(e.thumbs), (this.settings.slickMainInitialized = !0);
                        },
                        setSliderArgs: function () {
                            var t = {},
                                i = (this.settings.thumbVertical = "beside" === this.$thumbSlider.data("position")),
                                n = (this.settings.thumbArrows = this.$thumbSlider.data("arrows"));
                            return (
                                theme.config.bpSmall
                                    ? ((t.main = this.mainSliderArgs), (t.thumbs = this.thumbSliderArgs))
                                    : ((t.main = e.extend({}, this.mainSliderArgs, { asNavFor: this.selectors.thumbSlider, adaptiveHeight: !i, dots: !1, infinite: !1, fade: !0 })),
                                      (t.thumbs = e.extend({}, this.thumbSliderArgs, {
                                          asNavFor: this.selectors.mainSlider,
                                          slidesToShow: 1,
                                          slidesToScroll: 1,
                                          arrows: n,
                                          dots: !1,
                                          vertical: i,
                                          verticalSwiping: i,
                                          focusOnSelect: !0,
                                          infinite: !1,
                                          customHeightMatching: !n && i,
                                          customSlideAdvancement: !0,
                                      }))),
                                t
                            );
                        },
                        destroyImageCarousels: function () {
                            this.$mainSlider && this.settings.slickMainInitialized && (this.$mainSlider.slick("unslick"), (this.settings.slickMainInitialized = !1)),
                                this.$thumbSlider && this.settings.slickThumbInitialized && (this.$thumbSlider.slick("unslick"), (this.settings.slickThumbInitialized = !1)),
                                (this.settings.slickMainInitialized = !1),
                                (this.settings.slickThumbInitialized = !1);
                        },
                        mainSlideInit: function (e, t) {
                            var i = t.$slider.find(o.currentSlide).find(o.productVideo);
                            i.length && this.initVideo(i);
                        },
                        thumbSlideInit: function (e, t) {
                            (this.settings.slickThumbInitialized = !0), this.settings.thumbArrows && this.$thumbSlider.on("setPosition", this.thumbSlideArrowVisibility.bind(this));
                        },
                        thumbSlideArrowVisibility: function (e, t) {
                            var i = t.$slider,
                                n = i.find(".slick-arrow"),
                                o = !1;
                            this.settings.thumbVertical ? i.find(".slick-track").height() >= i.height() && (o = !0) : i.find(".slick-track").width() >= i.width() && (o = !0);
                            o ? n.removeClass("hide") : n.addClass("hide");
                        },
                        initVideo: function (n) {
                            var o = n.data("video-type"),
                                s = n.attr("id");
                            "mp4" === o && "muted" === a[s].style && this.playMp4Video(s),
                                "youtube" === o && t && "muted" === a[s].style && this.requestToPlayYoutubeVideo(s),
                                "vimeo" === o &&
                                    (i
                                        ? this.playOrShowVimeo(s)
                                        : e("body").on(
                                              "vimeoReady" + this.settings.namespace,
                                              function () {
                                                  this.playOrShowVimeo(s);
                                              }.bind(this)
                                          )),
                                this.inModal && this.resizeSlides();
                        },
                        stopVideo: function (e, t) {
                            e || (this.stopYoutubeVideo(), this.stopVimeoVideo(), this.stopMp4Video()), "youtube" === t && this.stopYoutubeVideo(e), "mp4" === t && this.stopMp4Video(e), "vimeo" === t && this.stopVimeoVideo(e);
                        },
                        playOrShowVimeo: function (t) {
                            a[t] && "muted" === a[t].style ? this.autoplayVimeoVideo(t) : a[t] && "unmuted" === a[t].style && p(e("#" + t));
                        },
                        getVideoType: function (e) {
                            return e.data("video-type");
                        },
                        getVideoId: function (e) {
                            return e.attr("id");
                        },
                        beforeSlideChange: function (n, s, r, c) {
                            var d = s.$slider,
                                l = d.find(o.currentSlide).find(".product__video"),
                                h = d.find('.slick-slide[data-slick-index="' + c + '"]').find(".product__video");
                            if (r !== c && l.length) {
                                var u = this.getVideoType(l),
                                    m = this.getVideoId(l);
                                m && this.stopVideo(m, u);
                            }
                            if (h.length) {
                                var f = this.getVideoType(h),
                                    g = this.getVideoId(h);
                                g &&
                                    "vimeo" === f &&
                                    (i
                                        ? a[g] && "muted" === a[g].style && this.autoplayVimeoVideo(g)
                                        : e("body").on(
                                              "vimeoReady" + this.settings.namespace,
                                              function () {
                                                  a[g] && "muted" === a[g].style && this.autoplayVimeoVideo(g);
                                              }.bind(this)
                                          )),
                                    g &&
                                        "youtube" === f &&
                                        (t
                                            ? a[g] && "muted" === a[g].style && this.requestToPlayYoutubeVideo(g, !0)
                                            : e("body").on(
                                                  "youTubeReady" + this.settings.namespace,
                                                  function () {
                                                      a[g] && "muted" === a[g].style && this.requestToPlayYoutubeVideo(g, !0);
                                                  }.bind(this)
                                              )),
                                    g && a[g] && "muted" === a[g].style && "mp4" === f && this.playMp4Video(g),
                                    g && a[g] && "muted" != a[g].style && p(e("#" + g));
                            }
                        },
                        resizeSlides: function () {
                            this.settings.hasMultipleImages &&
                                (e(window).trigger("resize.slick"),
                                setTimeout(
                                    function () {
                                        this.$mainSlider && this.settings.slickMainInitialized && this.$mainSlider.slick("setPosition"), this.$thumbSlider && this.settings.slickThumbInitialized && this.$thumbSlider.slick("setPosition");
                                    }.bind(this),
                                    500
                                ));
                        },
                        _slideIndex: function (e) {
                            return e.data("index");
                        },
                        initQtySelector: function () {
                            this.$container.find(".js-qty__wrapper").each(function () {
                                new theme.QtySelector(e(this), { namespace: ".product" });
                            });
                        },
                        initAjaxProductForm: function () {
                            "drawer" === theme.settings.cartType && new theme.AjaxProduct(e(this.selectors.formContainer));
                        },
                        openModalProduct: function () {
                            if (!this.settings.modalInit) {
                                var t = e(this.selectors.modalFormHolder),
                                    i = t.data("url");
                                (i += "?view=ajax"),
                                    t.load(
                                        i + " #AddToCartForm-" + this.sectionId,
                                        function () {
                                            t.addClass("is-active"), this.formSetup(), Shopify.PaymentButton && Shopify.PaymentButton.init();
                                        }.bind(this)
                                    ),
                                    this.productSetup(),
                                    this.loadModalContent(),
                                    this.createImageCarousels(),
                                    (this.settings.modalInit = !0);
                            }
                            this.resizeSlides(), this.addIdToRecentlyViewed();
                        },
                        closeModalProduct: function () {
                            this.stopVideo(), e("body").off(this.settings.namespace), e(window).off(this.settings.namespace);
                        },
                        loadModalContent: function () {
                            var t = this.checkIfVideos();
                            t &&
                                t.indexOf("mp4") > -1 &&
                                this.$modal.find('.product__video[data-video-type="mp4"]').each(
                                    function (t, i) {
                                        var n = e(i),
                                            o = n.data("video-src"),
                                            a = document.createElement("source");
                                        a.setAttribute("src", o), n.append(a);
                                    }.bind(this)
                                );
                        },
                        onUnload: function () {
                            this.$container.off(this.settings.namespace), e("body").off(this.settings.namespace), this.destroyImageCarousels();
                        },
                    })),
                    m
                );
            })()),
            (theme.Recommendations = (function () {
                function t(t) {
                    var i = (this.$container = e(t)),
                        n = (this.sectionId = i.attr("data-section-id"));
                    (this.selectors = { recommendations: "#Recommendations-" + n, placeholder: ".product-recommendations-placeholder", sectionClass: " .product-recommendations", productResults: ".grid-product" }), this.init();
                }
                return (
                    (t.prototype = e.extend({}, t.prototype, {
                        init: function () {
                            var t = e(this.selectors.recommendations);
                            if (t.length && !1 !== t.data("enable")) {
                                var i = t.find(this.selectors.placeholder),
                                    n = t.data("product-id"),
                                    o = "/recommendations/products?section_id=product-recommendations&limit=" + t.data("limit") + "&product_id=" + n;
                                i.load(
                                    o + this.selectors.sectionClass,
                                    function (i) {
                                        theme.reinitProductGridItem(t), this.updateVariantInventory(t), 0 === e(i).find(this.selectors.sectionClass).find(this.selectors.productResults).length && t.addClass("hide");
                                    }.bind(this)
                                );
                            }
                        },
                        updateVariantInventory: function (t) {
                            (window.inventories = window.inventories || {}),
                                t.find(".js-product-inventory-data").each(function () {
                                    var t = e(this),
                                        i = t.data("section-id");
                                    (window.inventories[i] = {}),
                                        e(".js-variant-inventory-data", t).each(function () {
                                            var t = e(this);
                                            window.inventories[i][t.data("id")] = { quantity: t.data("quantity"), incoming: t.data("incoming"), next_incoming_date: t.data("date") };
                                        });
                                });
                        },
                    })),
                    t
                );
            })()),
            (theme.CollectionHeader = (function () {
                var t = { hero: ".collection-hero", parallaxContainer: ".parallax-container" };
                function i(i) {
                    var n = e(i);
                    if (((this.namespace = ".collection-header"), (this.$heroContainer = n.find(t.hero)).length)) {
                        if ((this.checkIfNeedReload(), n.data("parallax"))) {
                            var o = n.find(t.parallaxContainer),
                                a = { namespace: this.namespace };
                            theme.parallaxSections[this.namespace] = new theme.Parallax(o, a);
                        }
                    } else theme.headerNav.disableOverlayHeader();
                }
                return (
                    (i.prototype = e.extend({}, i.prototype, {
                        checkIfNeedReload: function () {
                            Shopify.designMode && theme.settings.overlayHeader && (e(".header-wrapper").hasClass("is-light") || e(".header-wrapper").hasClass("header-wrapper--sticky") || location.reload());
                        },
                        onUnload: function () {
                            theme.parallaxSections[this.namespace] && (theme.parallaxSections[this.namespace].destroy(), delete theme.parallaxSections[this.namespace]);
                        },
                    })),
                    i
                );
            })()),
            (theme.CollectionSidebar = (function () {
                var t = !1;
                function i(t) {
                    (this.$container = e(t)), this.init();
                }
                return (
                    (i.prototype = e.extend({}, i.prototype, {
                        init: function () {
                            this.onUnload(), (t = "drawer" === this.$container.data("style")), (theme.FilterDrawer = new theme.Drawers("FilterDrawer", "collection-filters", !0));
                        },
                        forceReload: function () {
                            this.init();
                        },
                        onSelect: function () {
                            if (theme.FilterDrawer) {
                                if (!t) return void theme.FilterDrawer.close();
                                (t || theme.config.bpSmall) && theme.FilterDrawer.open();
                            }
                        },
                        onDeselect: function () {
                            theme.FilterDrawer && theme.FilterDrawer.close();
                        },
                        onUnload: function () {
                            theme.FilterDrawer && theme.FilterDrawer.close();
                        },
                    })),
                    i
                );
            })()),
            (theme.Collection = (function () {
                var t = ".grid-product__color-image",
                    i = ".color-swatch--with-image";
                function n(t) {
                    (this.container = t), (this.sectionId = e(t).attr("data-section-id")), (this.namespace = ".collection-" + this.sectionId), this.init();
                }
                return (
                    (n.prototype = e.extend({}, n.prototype, {
                        init: function () {
                            this.$container = e(this.container);
                            var t = (this.sectionId = this.$container.attr("data-section-id"));
                            (this.namespace = ".collection-" + t), this.sortBy(), this.colorSwatchHovering(), theme.reinitSection("collection-sidebar");
                        },
                        sortBy: function () {
                            var t = e("#SortBy");
                            t.length &&
                                t.on("change" + this.namespace, function () {
                                    location.href = "?sort_by=" + e(this).val();
                                });
                        },
                        colorSwatchHovering: function () {
                            e(t).length &&
                                e(i).on({
                                    mouseenter: function (t) {
                                        $el = e(t.currentTarget);
                                        var i = $el.data("variant-id"),
                                            n = $el.data("variant-image");
                                        e(".grid-product__color-image--" + i)
                                            .css("background-image", "url(" + n + ")")
                                            .addClass("is-active");
                                    },
                                    mouseleave: function (t) {
                                        $el = e(t.currentTarget);
                                        var i = $el.data("variant-id");
                                        e(".grid-product__color-image--" + i).removeClass("is-active");
                                    },
                                });
                        },
                        forceReload: function () {
                            this.onUnload(), this.init();
                        },
                        onUnload: function () {
                            e(window).off(this.namespace), this.$container.off(this.namespace), e(i).off(this.namespace);
                        },
                    })),
                    n
                );
            })()),
            (theme.HeaderSection = (function () {
                var t = "#NavDrawer",
                    i = ".mobile-nav__toggle-btn",
                    n = ".mobile-nav__has-sublist",
                    o = "mobile-nav--expanded";
                function a(t) {
                    var i = (this.$container = e(t));
                    this.sectionId = i.attr("data-section-id");
                    theme.reinitSection("slideshow-section"),
                        theme.currencySwitcher.init(),
                        this.initDrawers(),
                        theme.headerNav.init(),
                        theme.announcementBar.init(),
                        Shopify.designMode &&
                            setTimeout(function () {
                                e("body").trigger("resize");
                            }, 500);
                }
                return (
                    (a.prototype = e.extend({}, a.prototype, {
                        initDrawers: function () {
                            (theme.NavDrawer = new theme.Drawers("NavDrawer", "nav")), "drawer" === theme.settings.cartType && new theme.CartDrawer(), this.drawerMenuButtons();
                        },
                        drawerMenuButtons: function () {
                            e(t)
                                .find(".js-drawer-close")
                                .on("click", function (e) {
                                    e.preventDefault(), theme.NavDrawer.close();
                                });
                            var a = e(i);
                            a.attr("aria-expanded", "false"),
                                a.each(function (t, i) {
                                    var n = e(i);
                                    n.attr("aria-controls", n.attr("data-aria-controls"));
                                }),
                                a.on("click", function () {
                                    var t = e(this),
                                        i = !1;
                                    "true" === t.attr("aria-expanded") ? t.attr("aria-expanded", "false") : (t.attr("aria-expanded", "true"), (i = !0)), t.closest(n).toggleClass(o, i);
                                });
                        },
                        onBlockSelect: function (e) {
                            theme.announcementBar.onBlockSelect(e.detail.blockId);
                        },
                        onDeselect: function () {
                            theme.announcementBar.onBlockDeselect();
                        },
                        onUnload: function () {
                            theme.NavDrawer.close(), theme.headerNav.unload(), theme.announcementBar.unload();
                        },
                    })),
                    a
                );
            })()),
            (theme.FeaturedContentSection = (function () {
                return function () {
                    e(".rte").find("a:not(:has(img))").addClass("text-link");
                };
            })()),
            (theme.slideshows = {}),
            (theme.SlideshowSection = (function () {
                var t = { parallaxContainer: ".parallax-container" };
                function i(i) {
                    var n = (this.$container = e(i)),
                        o = (n.parent(), n.attr("data-section-id"));
                    this.slideshow = "#Slideshow-" + o;
                    this.namespace = "." + o;
                    var a = e(i).find(".hero");
                    if ((a.length && theme.loadImageSection(a), this.init(), n.data("parallax"))) {
                        var s = { namespace: this.namespace };
                        theme.parallaxSections[this.namespace] = new theme.Parallax(n.find(t.parallaxContainer), s);
                    }
                }
                return (
                    (i.prototype = e.extend({}, i.prototype, {
                        init: function () {
                            this.onUnload();
                            var t = e(this.slideshow),
                                i = { autoplay: t.data("autoplay"), arrows: t.data("arrows"), dots: t.data("dots"), fade: !0, speed: 500 };
                            theme.slideshows[this.slideshow] = new theme.Slideshow(this.slideshow, i);
                        },
                        forceReload: function () {
                            this.init();
                        },
                        onUnload: function () {
                            theme.parallaxSections[this.namespace] && (theme.parallaxSections[this.namespace].destroy(), delete theme.parallaxSections[this.namespace]),
                                theme.slideshows[this.slideshow] && (theme.slideshows[this.slideshow].destroy(), delete theme.slideshows[this.slideshow]);
                        },
                        onSelect: function () {
                            e(this.slideshow).slick("slickPause");
                        },
                        onDeselect: function () {
                            e(this.slideshow).slick("slickPlay");
                        },
                        onBlockSelect: function (t) {
                            var i = e(this.slideshow),
                                n = e(".slideshow__slide--" + t.detail.blockId + ":not(.slick-cloned)").data("slick-index");
                            i.slick("slickGoTo", n).slick("slickPause");
                        },
                        onBlockDeselect: function () {
                            e(this.slideshow).slick("slickPlay");
                        },
                    })),
                    i
                );
            })()),
            (theme.VideoSection = (function () {
                var t,
                    i = [],
                    n = [],
                    o = {
                        width: 1280,
                        height: 720,
                        playerVars: { autohide: 0, branding: 0, cc_load_policy: 0, controls: 0, fs: 0, iv_load_policy: 3, modestbranding: 1, playsinline: 1, quality: "hd720", rel: 0, showinfo: 0, wmode: "opaque" },
                        events: {
                            onReady: function (t) {
                                var i = e(t.target.a),
                                    o = i.attr("id");
                                n[o] = t.target;
                                n[o];
                                h(i), n[o].mute(), i.attr("tabindex", "-1"), l(o), e(window).on("scroll." + o, { id: o }, e.throttle(150, l));
                            },
                            onStateChange: function (t) {
                                var o = e(t.target.a),
                                    a = o.attr("id"),
                                    s = n[a];
                                switch (t.data) {
                                    case -1:
                                        i[a].attemptedToPlay && (u(o), p(o));
                                        break;
                                    case 0:
                                        s.playVideo();
                                        break;
                                    case 1:
                                        u(o);
                                        break;
                                    case 3:
                                        i[a].attemptedToPlay = !0;
                                }
                            },
                        },
                    },
                    a = !1,
                    s = { byline: !1, title: !1, portrait: !1, loop: !0 },
                    r = { videoParent: ".video-parent-section" },
                    c = { loading: "loading", loaded: "loaded", interactable: "video-interactable" };
                function d(t) {
                    var i = (this.$container = e(t)),
                        n = ((this.sectionId = i.attr("data-section-id")), (this.youtubePlayerId = "YouTubeVideo-" + this.sectionId));
                    this.namespace = "." + n;
                    var o = (this.vimeoPlayerId = "Vimeo-" + this.sectionId),
                        a = ((this.$vimeoTrigger = e("#VimeoTrigger-" + this.sectionId)), "Mp4Video-" + this.sectionId),
                        s = e("#" + n),
                        r = e("#" + o),
                        c = e("#" + a);
                    (this.vimeoPlayer = []),
                        s.length && ((this.youtubeVideoId = s.data("video-id")), this.initYoutubeVideo()),
                        r.length && ((this.vimeoVideoId = r.data("video-id")), this.initVimeoVideo()),
                        c.length &&
                            (u(c),
                            (function (e) {
                                return document.querySelector("#" + e).play();
                            })(a)
                                .then(function () {})
                                .catch(function (e) {
                                    p(c);
                                }));
                }
                function l(t) {
                    var i;
                    (i = "string" == typeof t ? t : !!t.data && t.data.id) &&
                        (theme.isElementVisible(e("#" + i))
                            ? (function (e) {
                                  n[e] && "function" == typeof n[e].playVideo && n[e].playVideo();
                              })(i)
                            : (function (e) {
                                  n[e] && "function" == typeof n[e].pauseVideo && n[e].pauseVideo();
                              })(i));
                }
                function h(e) {
                    e.closest(r.videoParent).addClass(c.loading);
                }
                function u(e) {
                    e.closest(r.videoParent).removeClass(c.loading).addClass(c.loaded);
                }
                function p(e) {
                    e.closest(r.videoParent).addClass(c.interactable);
                }
                return (
                    (d.prototype = e.extend({}, d.prototype, {
                        initYoutubeVideo: function () {
                            (i[this.youtubePlayerId] = { id: this.youtubePlayerId, videoId: this.youtubeVideoId, type: "youtube", attemptedToPlay: !1 }),
                                t ? this.loadYoutubeVideo() : (window.loadYouTube(), e("body").on("youTubeReady" + this.namespace, this.loadYoutubeVideo.bind(this)));
                        },
                        loadYoutubeVideo: function () {
                            var a = e.extend({}, o, i[this.youtubePlayerId]);
                            (a.playerVars.controls = 0), (n[this.youtubePlayerId] = new YT.Player(this.youtubePlayerId, a)), (t = !0);
                        },
                        initVimeoVideo: function () {
                            (i[this.vimeoPlayerId] = { divId: this.vimeoPlayerId, id: this.vimeoVideoId, type: "vimeo" }),
                                h(e("#" + this.vimeoPlayerId)),
                                this.$vimeoTrigger.on(
                                    "click",
                                    +this.namespace,
                                    function (e) {
                                        this.requestToPlayVimeoVideo(this.vimeoPlayerId);
                                    }.bind(this)
                                ),
                                a ? this.loadVimeoVideo() : (window.loadVimeo(), e("body").on("vimeoReady" + this.namespace, this.loadVimeoVideo.bind(this)));
                        },
                        loadVimeoVideo: function () {
                            var t = e.extend({}, s, i[this.vimeoPlayerId]);
                            ((this.vimeoPlayer[this.vimeoPlayerId] = new Vimeo.Player(i[this.vimeoPlayerId].divId, t)), (a = !0), theme.config.bpSmall) ? u(e("#" + this.vimeoPlayerId)) : this.requestToPlayVimeoVideo(this.vimeoPlayerId);
                        },
                        requestToPlayVimeoVideo: function (t) {
                            a
                                ? this.playVimeoVideo(t)
                                : e("body").on(
                                      "vimeoReady" + this.namespace,
                                      function () {
                                          this.playVimeoVideo(t);
                                      }.bind(this)
                                  );
                        },
                        playVimeoVideo: function (t) {
                            this.vimeoPlayer[t].play(), this.vimeoPlayer[t].setVolume(0), u(e("#" + t));
                        },
                        onUnload: function (t) {
                            var i = t.target.id.replace("shopify-section-", "");
                            n["YouTubeVideo-" + i].destroy(), e(window).off("scroll" + this.namespace), e("body").off("vimeoReady" + this.namespace);
                        },
                    })),
                    d
                );
            })()),
            (theme.BackgroundImage = (function () {
                var t = { parallaxContainer: ".parallax-container" };
                function i(i) {
                    var n = e(i),
                        o = n.attr("data-section-id");
                    if (((this.namespace = "." + o), n.length && n.data("parallax"))) {
                        var a = n.find(t.parallaxContainer),
                            s = { namespace: this.namespace, desktopOnly: !0 };
                        theme.parallaxSections[this.namespace] = new theme.Parallax(a, s);
                    }
                }
                return (
                    (i.prototype = e.extend({}, i.prototype, {
                        onUnload: function (e) {
                            theme.parallaxSections[this.namespace].destroy(), delete theme.parallaxSections[this.namespace];
                        },
                    })),
                    i
                );
            })()),
            (theme.Testimonials = (function () {
                var t = 0,
                    i = { accessibility: !0, arrows: !1, dots: !0, autoplay: !1, touchThreshold: 20, slidesToShow: 3, slidesToScroll: 3 };
                function n(n) {
                    var o = (this.$container = e(n)).attr("data-section-id"),
                        a = ((this.wrapper = ".testimonials-wrapper"), (this.slider = "#Testimonials-" + o)),
                        s = e(a);
                    this.sliderActive = !1;
                    var r = e.extend({}, i, { slidesToShow: 1, slidesToScroll: 1, adaptiveHeight: !0 });
                    (t = s.data("count")) < i.slidesToShow && ((i.slidesToShow = t), (i.slidesToScroll = t)),
                        s.on("init", this.a11y.bind(this)),
                        theme.config.bpSmall ? this.init(s, r) : this.init(s, i),
                        e("body").on(
                            "matchSmall",
                            function () {
                                this.init(s, r);
                            }.bind(this)
                        ),
                        e("body").on(
                            "matchLarge",
                            function () {
                                this.init(s, i);
                            }.bind(this)
                        );
                }
                return (
                    (n.prototype = e.extend({}, n.prototype, {
                        onUnload: function () {
                            e(this.slider, this.wrapper).slick("unslick");
                        },
                        onBlockSelect: function (t) {
                            var i = e(".testimonials-slide--" + t.detail.blockId + ":not(.slick-cloned)").data("slick-index");
                            e(this.slider, this.wrapper).slick("slickGoTo", i);
                        },
                        init: function (e, t) {
                            this.sliderActive && (e.slick("unslick"), (this.sliderActive = !1)), e.slick(t), (this.sliderActive = !0), AOS && AOS.refresh();
                        },
                        a11y: function (t, i) {
                            var n = i.$list,
                                o = e(this.wrapper, this.$container);
                            n.removeAttr("aria-live"),
                                o.on("focusin", function (e) {
                                    o.has(e.target).length && n.attr("aria-live", "polite");
                                }),
                                o.on("focusout", function (e) {
                                    o.has(e.target).length && n.removeAttr("aria-live");
                                });
                        },
                    })),
                    n
                );
            })()),
            (theme.Instagram = (function () {
                var t = !1;
                function i(t) {
                    var i = (this.$container = e(t)).attr("data-section-id");
                    (this.namespace = ".instagram-" + i), (this.$target = e("#Instafeed-" + i)), this.$target.length && (this.checkVisibility(), e(window).on("scroll" + this.namespace, e.throttle(100, this.checkVisibility.bind(this))));
                }
                return (
                    (i.prototype = e.extend({}, i.prototype, {
                        checkVisibility: function () {
                            t ? e(window).off("scroll" + this.namespace) : theme.isElementVisible(this.$container) && this.init();
                        },
                        init: function () {
                            t = !0;
                            var e = this.$target.data("user-id"),
                                i = this.$target.data("client-id"),
                                n = parseInt(this.$target.data("count")),
                                o = this.$target.data("grid-item-width");
                            (this.feed = new InstafeedTheme({
                                target: this.$target[0],
                                accessToken: i,
                                get: "user",
                                userId: e,
                                limit: n + 2,
                                template:
                                    '<div class="grid__item ' +
                                    o +
                                    '"><div class="image-wrap"><a href="{{link}}" target="_blank" style="background-image: url({{image}}); display: block; padding-bottom: 100%; background-size: cover; background-position: center;"></a></div></div>',
                                resolution: "standard_resolution",
                            })).run();
                        },
                    })),
                    i
                );
            })()),
            (theme.NewsletterPopup = (function () {
                function t(t) {
                    var i = (this.$container = e(t)),
                        n = i.attr("data-section-id");
                    (this.cookieName = "newsletter-" + n),
                        i.length &&
                            "/challenge" !== window.location.pathname &&
                            ((this.data = { secondsBeforeShow: i.data("delay-seconds"), daysBeforeReappear: i.data("delay-days"), cookie: Cookies.get(this.cookieName), testMode: i.data("test-mode") }),
                            (this.modal = new theme.Modals("NewsletterPopup-" + n, "newsletter-popup-modal")),
                            (i.find(".errors").length || i.find(".note--success").length) && this.modal.open(),
                            i.find(".note--success").length ? this.closePopup(!0) : (e("body").on("modalClose." + i.attr("id"), this.closePopup.bind(this)), (this.data.cookie && !this.data.testMode) || this.initPopupDelay()));
                }
                return (
                    (t.prototype = e.extend({}, t.prototype, {
                        initPopupDelay: function () {
                            setTimeout(
                                function () {
                                    this.modal.open();
                                }.bind(this),
                                1e3 * this.data.secondsBeforeShow
                            );
                        },
                        closePopup: function (e) {
                            if (this.data.testMode) Cookies.remove(this.cookieName, { path: "/" });
                            else {
                                var t = e ? 200 : this.data.daysBeforeReappear;
                                Cookies.set(this.cookieName, "opened", { path: "/", expires: t });
                            }
                        },
                        onLoad: function () {
                            this.modal.open();
                        },
                        onSelect: function () {
                            this.modal.open();
                        },
                        onDeselect: function () {
                            this.modal.close();
                        },
                        onUnload: function () {},
                    })),
                    t
                );
            })()),
            (theme.Maps = (function () {
                var t = 14,
                    i = null,
                    n = [],
                    o = { addressNoResults: theme.strings.addressNoResults, addressQueryLimit: theme.strings.addressQueryLimit, addressError: theme.strings.addressError, authError: theme.strings.authError },
                    a = { section: '[data-section-type="map"]', map: "[data-map]", mapOverlay: "[data-map-overlay]" },
                    s = "map-section--load-error",
                    r = "map-section__error errors text-center";
                function c(t) {
                    (this.$container = e(t)),
                        (this.sectionId = this.$container.attr("data-section-id")),
                        (this.namespace = ".map-" + this.sectionId),
                        (this.$map = this.$container.find(a.map)),
                        (this.key = this.$map.data("api-key")),
                        this.key && (this.checkVisibility(), e(window).on("scroll" + this.namespace, e.throttle(50, this.checkVisibility.bind(this))));
                }
                return (
                    (window.gm_authFailure = function () {
                        Shopify.designMode && (e(a.section).addClass(s), e(a.map).remove(), e(a.mapOverlay).after('<div class="' + r + '">' + theme.strings.authError + "</div>"));
                    }),
                    (c.prototype = e.extend({}, c.prototype, {
                        prepMapApi: function () {
                            "loaded" === i
                                ? this.createMap()
                                : (n.push(this),
                                  "loading" !== i &&
                                      ((i = "loading"),
                                      (void 0 !== window.google && void 0 !== window.google.maps) ||
                                          e.getScript("https://maps.googleapis.com/maps/api/js?key=" + this.key).then(function () {
                                              (i = "loaded"),
                                                  e.each(n, function (e, t) {
                                                      t.createMap();
                                                  });
                                          })));
                        },
                        createMap: function () {
                            var i = this.$map;
                            return (function (t) {
                                var i = e.Deferred(),
                                    n = new google.maps.Geocoder(),
                                    o = t.data("address-setting");
                                return (
                                    n.geocode({ address: o }, function (e, t) {
                                        t !== google.maps.GeocoderStatus.OK && i.reject(t), i.resolve(e);
                                    }),
                                    i
                                );
                            })(i)
                                .then(
                                    function (n) {
                                        var o = { zoom: t, backgroundColor: "none", center: n[0].geometry.location, draggable: !1, clickableIcons: !1, scrollwheel: !1, disableDoubleClickZoom: !0, disableDefaultUI: !0 },
                                            a = (this.map = new google.maps.Map(i[0], o)),
                                            s = (this.center = a.getCenter());
                                        new google.maps.Marker({ map: a, position: a.getCenter() });
                                        google.maps.event.addDomListener(
                                            window,
                                            "resize",
                                            e.debounce(250, function () {
                                                google.maps.event.trigger(a, "resize"), a.setCenter(s), i.removeAttr("style");
                                            })
                                        );
                                    }.bind(this)
                                )
                                .fail(function () {
                                    var e;
                                    switch (status) {
                                        case "ZERO_RESULTS":
                                            e = o.addressNoResults;
                                            break;
                                        case "OVER_QUERY_LIMIT":
                                            e = o.addressQueryLimit;
                                            break;
                                        case "REQUEST_DENIED":
                                            e = o.authError;
                                            break;
                                        default:
                                            e = o.addressError;
                                    }
                                    Shopify.designMode &&
                                        i
                                            .parent()
                                            .addClass(s)
                                            .html('<div class="' + r + '">' + e + "</div>");
                                });
                        },
                        checkVisibility: function () {
                            theme.isElementVisible(this.$container, 600) && (this.prepMapApi(), e(window).off(this.namespace));
                        },
                        onUnload: function () {
                            0 !== this.$map.length && google.maps.event.clearListeners(this.map, "resize");
                        },
                    })),
                    c
                );
            })()),
            (theme.Blog = (function () {
                function t(e) {
                    this.tagFilters();
                }
                return (
                    (t.prototype = e.extend({}, t.prototype, {
                        tagFilters: function () {
                            var t = e("#BlogTagFilter");
                            t.length &&
                                t.on("change", function () {
                                    location.href = e(this).val();
                                });
                        },
                        onUnload: function () {},
                    })),
                    t
                );
            })()),
            (theme.Photoswipe = (function () {
                var t = ".js-photoswipe__zoom",
                    i = ".photoswipe__image",
                    n = ".slick-active .photoswipe__image";
                function o(t, i) {
                    (this.$container = e(t)),
                        (this.sectionId = i),
                        (this.namespace = ".photoswipe-" + this.sectionId),
                        this.gallery,
                        this.$images,
                        (this.inSlideshow = !1),
                        "false" !== this.$container.attr("data-zoom") && ("true" === this.$container.attr("data-has-slideshow") && (this.inSlideshow = !0), this.init());
                }
                return (
                    (o.prototype = e.extend({}, o.prototype, {
                        init: function () {
                            var o = this.$container.find(t);
                            this.$images = this.$container.find(i);
                            var a = [];
                            o.on(
                                "click" + this.namespace,
                                function (t) {
                                    if (((a = this.getImageData()), this.inSlideshow)) var i = this.$container.find(n).data("index");
                                    else i = e(t.currentTarget).data("index");
                                    this.initGallery(a, i);
                                }.bind(this)
                            );
                        },
                        getImageData: function () {
                            var t = [];
                            return (
                                this.$images.each(function () {
                                    var i = {
                                        msrc: e(this).prop("currentSrc") || e(this).prop("src"),
                                        src: e(this).data("photoswipe-src"),
                                        w: e(this).data("photoswipe-width"),
                                        h: e(this).data("photoswipe-height"),
                                        el: e(this)[0],
                                        initialZoomLevel: 0.5,
                                    };
                                    t.push(i);
                                }),
                                t
                            );
                        },
                        initGallery: function (e, t) {
                            var i = document.querySelectorAll(".pswp")[0],
                                n = {
                                    allowPanToNext: !1,
                                    captionEl: !1,
                                    closeOnScroll: !1,
                                    counterEl: !1,
                                    history: !1,
                                    index: t - 1,
                                    pinchToClose: !1,
                                    preloaderEl: !1,
                                    scaleMode: "zoom",
                                    shareEl: !1,
                                    tapToToggleControls: !1,
                                    getThumbBoundsFn: function (t) {
                                        var i = window.pageYOffset || document.documentElement.scrollTop,
                                            n = e[t].el.getBoundingClientRect();
                                        return { x: n.left, y: n.top + i, w: n.width };
                                    },
                                };
                            (this.gallery = new PhotoSwipe(i, PhotoSwipeUI_Default, e, n)), this.gallery.init(), this.gallery.listen("afterChange", this.afterChange.bind(this));
                        },
                        afterChange: function () {
                            if (this.inSlideshow) {
                                var t = e("#ProductPhotos-" + this.sectionId);
                                if (t.hasClass("slick-initialized")) {
                                    var i = this.gallery.getCurrentIndex();
                                    t.slick("slickGoTo", i);
                                }
                            }
                        },
                    })),
                    o
                );
            })()),
            (theme.bp = {}),
            (theme.bp.smallUp = 769),
            (theme.bp.small = theme.bp.smallUp - 1),
            (theme.config = {
                bpSmall: !1,
                hasSessionStorage: !0,
                mediaQuerySmall: "screen and (max-width: " + theme.bp.small + "px)",
                mediaQuerySmallUp: "screen and (min-width: " + theme.bp.smallUp + "px)",
                youTubeReady: !1,
                vimeoReady: !1,
                vimeoLoading: !1,
                isTouch: !!("ontouchstart" in window || (window.DocumentTouch && window.document instanceof DocumentTouch) || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints),
                isIpad: /ipad/.test(window.navigator.userAgent.toLowerCase()) || ("MacIntel" === window.navigator.platform && window.navigator.maxTouchPoints > 1),
                stickyHeader: !1,
                recentlyViewed: [],
            }),
            theme.config.isIpad && (document.documentElement.className += " js-ipad"),
            (theme.recentlyViewed = { recent: {}, productInfo: {} }),
            (window.onYouTubeIframeAPIReady = function () {
                (theme.config.youTubeReady = !0), e("body").trigger("youTubeReady");
            }),
            (window.loadYouTube = function () {
                if (!theme.config.youtubeReady) {
                    var e = document.createElement("script");
                    e.src = "https://www.youtube.com/iframe_api";
                    var t = document.getElementsByTagName("script")[0];
                    t.parentNode.insertBefore(e, t);
                }
            }),
            (window.loadVimeo = function () {
                var t, i, n;
                if (!theme.config.vimeoLoading && !theme.config.vimeoReady) {
                    theme.config.vimeoLoading = !0;
                    var o = document.createElement("script");
                    o.src = "https://player.vimeo.com/api/player.js";
                    var a = document.getElementsByTagName("script")[0];
                    a.parentNode.insertBefore(o, a),
                        ((n = e.Deferred()),
                        (t = setInterval(function () {
                            Vimeo && (clearInterval(t), clearTimeout(i), n.resolve());
                        }, 500)),
                        (i = setTimeout(function () {
                            clearInterval(t), n.reject();
                        }, 4e3)),
                        n)
                            .then(function () {
                                (theme.config.vimeoReady = !0), (theme.config.vimeoLoading = !1), e("body").trigger("vimeoReady");
                            })
                            .fail(function () {});
                }
            }),
            (theme.init = function () {
                theme.setGlobals(),
                    theme.pageTransitions(),
                    theme.collapsibles.init(),
                    slate.rte.init(),
                    AOS.init({ easing: "ease-out-quad", once: !0, offset: 60, disableMutationObserver: !0 }),
                    e(document.documentElement).on("keyup.tab", function (t) {
                        9 === t.keyCode && (e(document.documentElement).addClass("tab-outline"), e(document.documentElement).off("keyup.tab"));
                    }),
                    e(".footer__newsletter-input").on("keyup", function () {
                        e(this).addClass("footer__newsletter-input--active");
                    });
            }),
            (theme.initSecondary = function () {
                theme.initQuickShop(), theme.settings.predictiveSearch && theme.predictiveSearch.init(), theme.collectionTemplate.init(), theme.customerTemplates.init(), theme.videoModal();
            }),
            (theme.setGlobals = function () {
                (theme.config.hasSessionStorage = theme.isSessionStorageSupported()),
                    (theme.recentlyViewed.handleCookie = Cookies.get("theme-recent")),
                    theme.recentlyViewed.handleCookie && (theme.recentlyViewed.recent = JSON.parse(theme.recentlyViewed.handleCookie)),
                    (theme.recentlyViewed.productInfo = theme.config.hasSessionStorage && sessionStorage["recent-products"] ? JSON.parse(sessionStorage["recent-products"]) : {}),
                    theme.config.isTouch && e("body").addClass("supports-touch"),
                    enquire.register(theme.config.mediaQuerySmall, {
                        match: function () {
                            (theme.config.bpSmall = !0), e("body").trigger("matchSmall");
                        },
                        unmatch: function () {
                            (theme.config.bpSmall = !1), e("body").trigger("unmatchSmall");
                        },
                    }),
                    enquire.register(theme.config.mediaQuerySmallUp, {
                        match: function () {
                            e("body").trigger("matchLarge");
                        },
                        unmatch: function () {
                            e("body").trigger("unmatchLarge");
                        },
                    });
            }),
            (theme.loadImageSection = function (e) {
                function t() {
                    e.removeClass("loading loading--delayed").addClass("loaded");
                }
                function i() {
                    return e.find(".lazyloaded").length;
                }
                if (e.find("svg").length) t();
                else if (i() > 0) t();
                else
                    var n = setInterval(function () {
                        i() > 0 && (clearInterval(n), t());
                    }, 80);
            }),
            (theme.isSessionStorageSupported = function () {
                if (window.self !== window.top) return !1;
                var e = window.sessionStorage;
                try {
                    return e.setItem("test", "1"), e.removeItem("test"), !0;
                } catch (e) {
                    return !1;
                }
            }),
            (theme.isElementVisible = function (e, t) {
                var i = e[0].getBoundingClientRect(),
                    n = window.innerHeight || document.documentElement.clientHeight;
                return (t = t || 0), i.bottom >= 0 && i.right >= 0 && i.top <= n + t && i.left <= (window.innerWidth || document.documentElement.clientWidth);
            }),
            (theme.pageTransitions = function () {
                if (1 == e("body").data("transitions")) {
                    var t = ".page-transition";
                    navigator.userAgent.match(/Version\/[\d\.]+.*Safari/) &&
                        e("a")
                            .off(t)
                            .on("click" + t, function () {
                                window.setTimeout(function () {
                                    e("body").removeClass("unloading");
                                }, 1200);
                            }),
                        e('a[href^="mailto:"], a[href^="#"], a[target="_blank"], a[href*="youtube.com/watch"], a[href*="youtu.be/"]').each(function () {
                            e(this).addClass("js-no-transition");
                        }),
                        e("a:not(.js-no-transition)")
                            .off(t)
                            .on("click" + t, function (t) {
                                if (t.metaKey) return !0;
                                t.preventDefault(), e("body").addClass("unloading");
                                var i = e(this).attr("href");
                                window.setTimeout(function () {
                                    location.href = i;
                                }, 50);
                            }),
                        e("a.mobile-nav__link")
                            .off(t)
                            .on("click" + t, function () {
                                theme.NavDrawer.close();
                            });
                }
            }),
            (theme.reinitSection = function (e) {
                for (var t = 0; t < sections.instances.length; t++) {
                    var i = sections.instances[t];
                    i.type === e && "function" == typeof i.forceReload && i.forceReload();
                }
            }),
            (theme.reinitProductGridItem = function (e) {
                AOS && AOS.refreshHard(),
                    theme.settings.currenciesEnabled && theme.currencySwitcher.ajaxrefresh(),
                    theme.initQuickShop(!0),
                    window.SPR && (SPR.initDomEls(), SPR.loadBadges()),
                    sections.register("product-template", theme.Product, e),
                    theme.collapsibles.init();
            }),
            (window.onpageshow = function (t) {
                t.persisted && e("body").removeClass("unloading");
            }),
            e(document).ready(function () {
                theme.init(),
                    (window.sections = new theme.Sections()),
                    sections.register("header-section", theme.HeaderSection),
                    sections.register("slideshow-section", theme.SlideshowSection),
                    sections.register("video-section", theme.VideoSection),
                    sections.register("background-image", theme.BackgroundImage),
                    sections.register("recently-viewed", theme.RecentlyViewed),
                    sections.register("product", theme.Product),
                    sections.register("product-recommendations", theme.Recommendations),
                    sections.register("product-template", theme.Product),
                    sections.register("collection-header", theme.CollectionHeader),
                    sections.register("collection-sidebar", theme.CollectionSidebar),
                    sections.register("collection-template", theme.Collection),
                    sections.register("featured-content-section", theme.FeaturedContentSection),
                    sections.register("testimonials", theme.Testimonials),
                    sections.register("instagram", theme.Instagram),
                    sections.register("newsletter-popup", theme.NewsletterPopup),
                    sections.register("map", theme.Maps),
                    sections.register("blog", theme.Blog),
                    sections.register("photoswipe", theme.Photoswipe),
                    theme.initSecondary();
            });
    })(theme.jQuery);
